import React, { useState, useEffect, useRef } from 'react';

const ADMIN_EMAILS = ["urijmiller@gmail.com"];

// =============================================
// SVG Icon Components (replacing emojis)
// =============================================
const Icons = {
  // Analytics & Charts
  BarChart: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  TrendingUp: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
    </svg>
  ),
  // Devices
  Desktop: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Mobile: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  ),
  Tablet: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  ),
  // Features
  Search: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  Calendar: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  Document: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  Folder: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
    </svg>
  ),
  // Actions
  Click: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
    </svg>
  ),
  // Users
  Users: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  // Time
  Clock: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  // Browser/Globe
  Globe: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
    </svg>
  ),
  // Share
  Share: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
    </svg>
  ),
  // Star/Watchlist
  Star: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
  ),
  // AI/Sparkles
  Sparkles: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  // X (formerly Twitter)
  XLogo: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),
  // Bookmark
  Bookmark: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
    </svg>
  ),
  // Poll/Chart
  ChartPie: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
    </svg>
  ),
  // Lightbulb/Ideas
  Lightbulb: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  // External Link
  ExternalLink: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
    </svg>
  ),
  // Filter
  Filter: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
    </svg>
  ),
  // Plus
  Plus: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  ),
  // Trash
  Trash: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  ),
  // Sort
  Sort: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
    </svg>
  ),
  // Apple (iOS)
  Apple: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
    </svg>
  ),
  // Android
  Android: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.523 2.047l1.378 2.388a.25.25 0 01-.216.375h-.017a.25.25 0 01-.217-.125L17.06 2.23c-1.173.51-2.477.794-3.86.794-1.383 0-2.687-.284-3.86-.794l-1.391 2.455a.25.25 0 01-.217.125h-.017a.25.25 0 01-.216-.375l1.378-2.388C5.91 3.633 3.8 6.296 3.6 9.5h17.2c-.2-3.204-2.31-5.867-5.277-7.453zM8.25 7.5a.75.75 0 110-1.5.75.75 0 010 1.5zm7.5 0a.75.75 0 110-1.5.75.75 0 010 1.5zM3.5 10.5h17v9a2 2 0 01-2 2h-13a2 2 0 01-2-2v-9z"/>
    </svg>
  ),
  // Windows
  Windows: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M3 5.548l7.065-.966v6.822H3V5.548zm0 12.904l7.065.966v-6.822H3v5.856zm7.952 1.085L21 21v-9.596h-10.048v8.133zm0-15.074v8.133H21V3l-10.048 1.463z"/>
    </svg>
  ),
  // Linux
  Linux: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.504 0c-.155 0-.311.004-.466.012-2.904.144-5.453 1.966-6.705 4.7-.572 1.251-.913 2.645-1.012 4.082-.037.545-.046 1.092-.028 1.637.018.545.062 1.089.133 1.628.143 1.078.403 2.125.773 3.116.37.99.85 1.923 1.43 2.772.58.85 1.257 1.614 2.015 2.274.758.66 1.594 1.215 2.49 1.648.896.433 1.85.742 2.837.914.987.172 2.003.206 3.015.103 1.012-.103 2-.341 2.937-.707.937-.367 1.82-.859 2.624-1.465.804-.606 1.526-1.323 2.143-2.131.617-.808 1.13-1.705 1.522-2.66.392-.955.664-1.965.812-3.001.074-.518.123-1.041.147-1.565.024-.524.023-1.049-.003-1.573-.052-1.048-.212-2.087-.475-3.095-.263-1.008-.63-1.983-1.09-2.897-.46-.914-1.014-1.764-1.65-2.525-.636-.761-1.354-1.43-2.138-1.989-.784-.559-1.633-1.006-2.527-1.325-.894-.319-1.831-.508-2.786-.562-.159-.009-.318-.013-.477-.013z"/>
    </svg>
  ),
  // Chrome
  Chrome: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0C8.21 0 4.831 1.757 2.632 4.501l3.953 6.848A5.454 5.454 0 0112 6.545h10.691A12 12 0 0012 0zM1.931 5.47A11.943 11.943 0 000 12c0 6.012 4.42 10.991 10.189 11.864l3.953-6.847a5.45 5.45 0 01-6.865-2.29zm13.342 2.166a5.446 5.446 0 011.45 7.09l.002.001h-.002l-3.952 6.848a12.014 12.014 0 009.167-4.13A11.94 11.94 0 0024 12c0-.807-.082-1.594-.235-2.364z"/>
    </svg>
  ),
  // Safari
  Safari: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.5-4.5l7-11.5-7 11.5zm3-7l-7 11.5 7-11.5z"/>
    </svg>
  ),
  // Firefox
  Firefox: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.001 0C5.384 0 0 5.384 0 12.001s5.384 12 12.001 12c6.616 0 12-5.384 12-12.001C24.001 5.384 18.617 0 12.001 0z"/>
    </svg>
  ),
  // Edge
  Edge: ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M21.86 17.86q.14 0 .25.12.1.13.1.25t-.11.33l-.32.46-.43.53-.44.5q-.21.25-.38.42l-.22.23q-.58.53-1.34 1.04-.76.51-1.6.91-.86.4-1.74.64t-1.67.24q-.9 0-1.69-.28-.8-.28-1.48-.78-.68-.5-1.22-1.17-.53-.66-.89-1.42-.36-.76-.57-1.57-.2-.8-.2-1.6 0-.96.27-1.91.27-.96.78-1.84.51-.88 1.27-1.62.77-.73 1.76-1.22.99-.49 2.17-.7 1.18-.2 2.52-.03 1.36.17 2.85.74 1.5.56 3.08 1.62-1.48-1.48-3.51-2.35-2.03-.86-4.07-.86-2.03 0-3.84.75-1.82.75-3.16 2.01-1.34 1.25-2.1 2.91-.77 1.67-.77 3.55 0 1.63.51 3.14.51 1.5 1.52 2.65.23.28.48.52.25.23.52.44-.67-.13-1.3-.49-.64-.36-1.2-.91-.55-.54-1-1.28-.44-.74-.72-1.65-.27-.9-.27-1.99 0-2.1.81-3.86.81-1.77 2.12-2.97 1.3-1.19 2.96-1.77 1.65-.58 3.34-.58 1.34 0 2.55.37 1.2.37 2.22 1.04 1.02.68 1.82 1.62.8.93 1.33 2.02.52 1.09.8 2.29.27 1.19.27 2.42 0 .56-.07 1.09-.07.52-.17 1.03 0 .03-.02.05t-.04.04q-.02.02-.05.03t-.06.01h-8.64q0 .77.29 1.44.29.66.78 1.17.49.5 1.14.8.64.3 1.36.3.67 0 1.38-.19.72-.19 1.38-.54.65-.35 1.19-.83.53-.47.86-1.04 0-.01.02-.03t.04-.04.05-.03.06-.01z"/>
    </svg>
  ),
};

// Tooltip component - works on both desktop (hover) and mobile (tap)
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef(null);

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(!show);
  };

  return (
    <div className="relative inline-block" ref={tooltipRef}>
      <div
        onClick={handleToggle}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="cursor-help"
      >
        {children}
      </div>
      {show && (
        <div 
          className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 text-xs text-white bg-slate-900 rounded-lg shadow-lg max-w-[200px] sm:max-w-xs"
          style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
        >
          {text}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-900" />
        </div>
      )}
    </div>
  );
};

// Info icon for tooltips
const InfoIcon = () => (
  <svg className="w-3.5 h-3.5 inline-block ml-1 text-slate-400 hover:text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

// Stat Card component - moved outside to prevent re-render issues
const StatCard = ({ title, value, change, subtitle, icon, color = "blue", tooltip, isDarkMode }) => (
  <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
    <div className="flex items-center justify-between mb-2">
      <span className={`text-xs font-medium uppercase tracking-wide ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
        {title}
        {tooltip && <Tooltip text={tooltip}><InfoIcon /></Tooltip>}
      </span>
      <span className={`text-${color}-500`}>{icon}</span>
    </div>
    <div className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
      {typeof value === 'number' ? value.toLocaleString() : value}
    </div>
    {change !== undefined && (
      <div className="flex items-center mt-1">
        <span className={`text-xs ${change >= 0 ? 'text-green-500' : 'text-red-500'}`}>
          {change >= 0 ? '↑' : '↓'} {Math.abs(change)}%
        </span>
        <span className={`text-xs ml-1 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>vs last week</span>
      </div>
    )}
    {subtitle && (
      <div className={`text-xs mt-1 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{subtitle}</div>
    )}
  </div>
);

export default function AdminDashboard({ user, API_BASE_URL, isDarkMode }) {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSection, setActiveSection] = useState('overview');
  
  // Beta Access Management state
  const [waitlistUsers, setWaitlistUsers] = useState([]);
  const [approvedUsers, setApprovedUsers] = useState([]);
  const [betaLoading, setBetaLoading] = useState(false);
  const [approvingUser, setApprovingUser] = useState(null);
  const [manualApproveUsername, setManualApproveUsername] = useState('');
  
  // SaaS Metrics state
  const [saasMetrics, setSaasMetrics] = useState(null);
  const [marketingSpend, setMarketingSpend] = useState({
    month: new Date().toISOString().slice(0, 7),
    paid_ads: '',
    content_seo: '',
    sales_salaries: '',
    tools_software: '',
    other: '',
    notes: ''
  });
  const [savingSpend, setSavingSpend] = useState(false);
  const [syncingStripe, setSyncingStripe] = useState(false);

  const isAdmin = user?.email && ADMIN_EMAILS.includes(user.email);

  useEffect(() => {
    if (!isAdmin) {
      setLoading(false);
      return;
    }

    const fetchMetrics = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/admin/metrics?admin_email=${encodeURIComponent(user.email)}`
        );
        if (!response.ok) throw new Error('Failed to fetch metrics');
        const data = await response.json();
        setMetrics(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [isAdmin, user?.email, API_BASE_URL]);

  // Fetch SaaS metrics when tab is selected
  useEffect(() => {
    if (activeSection === 'saas' && isAdmin) {
      fetchSaasMetrics();
    }
  }, [activeSection, isAdmin]);

  const fetchSaasMetrics = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/admin/saas-metrics?admin_email=${encodeURIComponent(user.email)}`
      );
      if (response.ok) {
        const data = await response.json();
        setSaasMetrics(data);
        // Pre-fill marketing spend form if data exists
        if (data.marketing) {
          setMarketingSpend(prev => ({
            ...prev,
            paid_ads: data.marketing.paid_ads || '',
            content_seo: data.marketing.content_seo || '',
            sales_salaries: data.marketing.sales_salaries || '',
            tools_software: data.marketing.tools_software || '',
            other: data.marketing.other || '',
            notes: data.marketing.notes || ''
          }));
        }
      }
    } catch (err) {
      console.error('Error fetching SaaS metrics:', err);
    }
  };

  const saveMarketingSpend = async () => {
    setSavingSpend(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/admin/marketing-spend?admin_email=${encodeURIComponent(user.email)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...marketingSpend,
            paid_ads: parseFloat(marketingSpend.paid_ads) || 0,
            content_seo: parseFloat(marketingSpend.content_seo) || 0,
            sales_salaries: parseFloat(marketingSpend.sales_salaries) || 0,
            tools_software: parseFloat(marketingSpend.tools_software) || 0,
            other: parseFloat(marketingSpend.other) || 0
          })
        }
      );
      if (response.ok) {
        fetchSaasMetrics(); // Refresh metrics
      }
    } catch (err) {
      console.error('Error saving marketing spend:', err);
    } finally {
      setSavingSpend(false);
    }
  };

  const syncStripeData = async () => {
    setSyncingStripe(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/admin/sync-stripe?admin_email=${encodeURIComponent(user.email)}`,
        { method: 'POST' }
      );
      if (response.ok) {
        fetchSaasMetrics(); // Refresh metrics
      }
    } catch (err) {
      console.error('Error syncing Stripe:', err);
    } finally {
      setSyncingStripe(false);
    }
  };

  // Beta Access Management Functions
  const ADMIN_API_KEY = 'JpiLMLN2dQN5RLfCx0Bd55piq9hiyufZo_3acZ_pwoM';
  
  const fetchBetaData = async () => {
    setBetaLoading(true);
    try {
      const [waitlistRes, approvedRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/admin/waitlist`, {
          headers: { 'X-Admin-Key': ADMIN_API_KEY }
        }),
        fetch(`${API_BASE_URL}/api/admin/approved-users`, {
          headers: { 'X-Admin-Key': ADMIN_API_KEY }
        })
      ]);
      
      if (waitlistRes.ok) {
        const data = await waitlistRes.json();
        setWaitlistUsers(data.users || []);
      }
      if (approvedRes.ok) {
        const data = await approvedRes.json();
        setApprovedUsers(data.users || []);
      }
    } catch (err) {
      console.error('Error fetching beta data:', err);
    } finally {
      setBetaLoading(false);
    }
  };

  const approveUser = async (xUsername, userId, xId) => {
    setApprovingUser(xUsername || userId);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/approve-beta-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Key': ADMIN_API_KEY
        },
        body: JSON.stringify({ 
          x_username: xUsername,
          user_id: userId,
          x_id: xId
        })
      });
      
      if (response.ok) {
        // Refresh both lists
        fetchBetaData();
      } else {
        const error = await response.json();
        alert(`Error: ${error.detail || 'Failed to approve user'}`);
      }
    } catch (err) {
      console.error('Error approving user:', err);
      alert('Failed to approve user');
    } finally {
      setApprovingUser(null);
    }
  };

  const revokeUser = async (identifier) => {
    if (!confirm(`Revoke beta access for ${identifier}?`)) return;
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/revoke-beta-user/${encodeURIComponent(identifier)}`, {
        method: 'DELETE',
        headers: { 'X-Admin-Key': ADMIN_API_KEY }
      });
      
      if (response.ok) {
        fetchBetaData();
      } else {
        const error = await response.json();
        alert(`Error: ${error.detail || 'Failed to revoke access'}`);
      }
    } catch (err) {
      console.error('Error revoking user:', err);
      alert('Failed to revoke access');
    }
  };

  const approveAllExisting = async () => {
    if (!confirm('This will approve ALL existing users for beta access. Continue?')) return;
    
    setBetaLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/approve-all-existing-users`, {
        method: 'POST',
        headers: { 'X-Admin-Key': ADMIN_API_KEY }
      });
      
      if (response.ok) {
        const data = await response.json();
        alert(`Approved ${data.newly_approved} existing users for beta!`);
        fetchBetaData();
      }
    } catch (err) {
      console.error('Error approving all users:', err);
      alert('Failed to approve existing users');
    } finally {
      setBetaLoading(false);
    }
  };

  const handleManualApprove = async (e) => {
    e.preventDefault();
    if (!manualApproveUsername.trim()) return;
    
    await approveUser(manualApproveUsername.trim().replace('@', ''));
    setManualApproveUsername('');
  };

  // Load beta data when switching to beta section
  useEffect(() => {
    if (activeSection === 'beta' && isAdmin) {
      fetchBetaData();
    }
  }, [activeSection, isAdmin]);

  if (!isAdmin) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-slate-900' : 'bg-slate-50'}`}>
        <div className={`text-center p-8 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-lg`}>
          <svg className="w-16 h-16 mx-auto mb-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h2 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>Access Denied</h2>
          <p className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>Admin access required</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-slate-900' : 'bg-slate-50'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-slate-900' : 'bg-slate-50'}`}>
        <div className={`text-center p-8 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-lg`}>
          <p className="text-red-500">Error: {error}</p>
        </div>
      </div>
    );
  }

  const calcGrowth = (thisWeek, lastWeek) => {
    if (lastWeek === 0) return thisWeek > 0 ? 100 : 0;
    return Math.round(((thisWeek - lastWeek) / lastWeek) * 100);
  };

  const userGrowth = calcGrowth(metrics?.this_week?.new_users || 0, metrics?.last_week?.new_users || 0);
  const ideaGrowth = calcGrowth(metrics?.this_week?.new_ideas || 0, metrics?.last_week?.new_ideas || 0);
  const shareGrowth = calcGrowth(metrics?.this_week?.new_shares || 0, metrics?.last_week?.new_shares || 0);
  const maxIdeas = Math.max(...(metrics?.trends?.daily_ideas || []).map(d => d.count), 1);
  const maxActive = Math.max(...(metrics?.trends?.daily_active || []).map(d => d.count), 1);

  const sections = [
    { id: 'overview', label: 'Overview' },
    { id: 'beta', label: 'Beta Access' },
    { id: 'saas', label: 'SaaS Metrics' },
    { id: 'revenue', label: 'Revenue' },
    { id: 'growth', label: 'Growth' },
    { id: 'retention', label: 'Retention' },
    { id: 'engagement', label: 'Engagement' },
    { id: 'virality', label: 'Virality' },
    { id: 'imports', label: 'Imports' },
    { id: 'features', label: 'Features' },
    { id: 'content', label: 'Content' },
    { id: 'journey', label: 'Journey' },
    { id: 'health', label: 'Health' },
  ];

  return (
    <div className={`min-h-screen p-4 sm:p-6 ${isDarkMode ? 'bg-slate-900' : 'bg-slate-50'}`}>
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="mb-6">
          <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
            Admin Dashboard
          </h1>
          <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
            Privacy-first analytics • Aggregate data only • No PII
          </p>
        </div>

        {/* Section Tabs */}
        <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
          {sections.map(section => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                activeSection === section.id
                  ? 'bg-orange-500 text-white'
                  : isDarkMode 
                    ? 'bg-slate-800 text-slate-300 hover:bg-slate-700' 
                    : 'bg-white text-slate-600 hover:bg-slate-100'
              }`}
            >
              {section.label}
            </button>
          ))}
        </div>

        {/* ==================== OVERVIEW SECTION ==================== */}
        {activeSection === 'overview' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Total Users" 
                value={metrics?.totals?.users || 0}
                change={userGrowth}
                subtitle={`+${metrics?.this_week?.new_users || 0} this week`}
                tooltip="Total registered users on the platform"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Total Ideas" 
                value={metrics?.totals?.ideas || 0}
                change={ideaGrowth}
                subtitle={`+${metrics?.this_week?.new_ideas || 0} this week`}
                tooltip="Investment ideas imported and created by all users"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Groups" 
                value={metrics?.totals?.groups || 0}
                subtitle={`+${metrics?.this_week?.new_groups || 0} this week`}
                tooltip="Investment groups created for collaboration"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Ideas Shared" 
                value={metrics?.totals?.shares || 0}
                change={shareGrowth}
                subtitle={`+${metrics?.this_week?.new_shares || 0} this week`}
                tooltip="Ideas shared between users or to groups"
                color="orange"
              />
            </div>

            {/* Activity & Trends */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Activity (Last 7 Days)
                </h3>
                <div className="space-y-3">
                  {[
                    { label: 'New signups', value: metrics?.this_week?.new_users || 0 },
                    { label: 'Ideas imported', value: metrics?.this_week?.new_ideas || 0 },
                    { label: 'Ideas shared', value: metrics?.this_week?.new_shares || 0 },
                    { label: 'Groups created', value: metrics?.this_week?.new_groups || 0 },
                    { label: 'Active users', value: metrics?.active_users?.wau || 0, highlight: true },
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.label}</span>
                      <span className={`text-lg font-bold ${item.highlight ? 'text-green-500' : isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm lg:col-span-2`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Ideas (Last 30 Days)
                </h3>
                <div className="h-24 flex items-end gap-1">
                  {metrics?.trends?.daily_ideas?.slice(-30).map((day, idx) => (
                    <div
                      key={idx}
                      className="flex-1 bg-green-500 rounded-t hover:bg-green-400 transition-colors"
                      style={{ height: `${Math.max((day.count / maxIdeas) * 100, 2)}%` }}
                      title={`${day.date}: ${day.count} ideas`}
                    />
                  ))}
                </div>
                <div className="flex justify-between mt-2">
                  <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>30 days ago</span>
                  <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>Today</span>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== BETA ACCESS SECTION ==================== */}
        {activeSection === 'beta' && (
          <div className="space-y-6">
            {/* Header with actions */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                  Beta Access Management
                </h3>
                <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  Manage who can access the platform during beta
                </p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={fetchBetaData}
                  disabled={betaLoading}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isDarkMode 
                      ? 'bg-slate-700 hover:bg-slate-600 text-white' 
                      : 'bg-slate-200 hover:bg-slate-300 text-slate-800'
                  }`}
                >
                  {betaLoading ? 'Loading...' : 'Refresh'}
                </button>
                <button
                  onClick={approveAllExisting}
                  disabled={betaLoading}
                  className="px-4 py-2 rounded-lg text-sm font-medium bg-green-600 hover:bg-green-700 text-white transition-colors"
                >
                  Approve All Existing Users
                </button>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <div className={`text-2xl font-bold ${isDarkMode ? 'text-amber-400' : 'text-amber-600'}`}>
                  {waitlistUsers.length}
                </div>
                <div className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  On Waitlist
                </div>
              </div>
              <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <div className={`text-2xl font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                  {approvedUsers.length}
                </div>
                <div className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  Approved Users
                </div>
              </div>
            </div>

            {/* Manual Approve */}
            <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h4 className={`text-sm font-semibold mb-3 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Quick Approve by X Username
              </h4>
              <form onSubmit={handleManualApprove} className="flex gap-2">
                <input
                  type="text"
                  value={manualApproveUsername}
                  onChange={(e) => setManualApproveUsername(e.target.value)}
                  placeholder="@username"
                  className={`flex-1 px-3 py-2 rounded-lg border text-sm ${
                    isDarkMode 
                      ? 'bg-slate-700 border-slate-600 text-white placeholder-slate-400' 
                      : 'bg-white border-slate-300 text-slate-900 placeholder-slate-400'
                  }`}
                />
                <button
                  type="submit"
                  disabled={!manualApproveUsername.trim() || approvingUser}
                  className="px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white transition-colors disabled:opacity-50"
                >
                  Approve
                </button>
              </form>
            </div>

            {/* Waitlist */}
            <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h4 className={`text-sm font-semibold mb-3 flex items-center gap-2 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                Waitlist ({waitlistUsers.length})
              </h4>
              {waitlistUsers.length === 0 ? (
                <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  No users on waitlist
                </p>
              ) : (
                <div className="space-y-2 max-h-80 overflow-y-auto">
                  {waitlistUsers.map((u, idx) => (
                    <div 
                      key={u.user_id || u.x_id || idx}
                      className={`flex items-center justify-between p-3 rounded-lg ${
                        isDarkMode ? 'bg-slate-700/50' : 'bg-slate-50'
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                          isDarkMode ? 'bg-slate-600' : 'bg-slate-200'
                        }`}>
                          <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                            {(u.x_username || u.x_display_name || '?')[0].toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <div className={`font-medium text-sm ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                            {u.x_display_name || u.x_username || 'Unknown'}
                          </div>
                          <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                            @{u.x_username || 'no-username'} • Joined {new Date(u.joined_at).toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={() => approveUser(u.x_username, u.user_id, u.x_id)}
                        disabled={approvingUser === (u.x_username || u.user_id)}
                        className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                          approvingUser === (u.x_username || u.user_id)
                            ? 'bg-slate-300 text-slate-500'
                            : 'bg-green-600 hover:bg-green-700 text-white'
                        }`}
                      >
                        {approvingUser === (u.x_username || u.user_id) ? 'Approving...' : 'Approve'}
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Approved Users */}
            <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h4 className={`text-sm font-semibold mb-3 flex items-center gap-2 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Approved Users ({approvedUsers.length})
              </h4>
              {approvedUsers.length === 0 ? (
                <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  No approved users yet
                </p>
              ) : (
                <div className="space-y-2 max-h-80 overflow-y-auto">
                  {approvedUsers.map((u, idx) => (
                    <div 
                      key={u.user_id || u.x_id || idx}
                      className={`flex items-center justify-between p-3 rounded-lg ${
                        isDarkMode ? 'bg-slate-700/50' : 'bg-slate-50'
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center bg-green-500/20`}>
                          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                        <div>
                          <div className={`font-medium text-sm ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
                            @{u.x_username || 'no-username'}
                          </div>
                          <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                            Approved {new Date(u.approved_at).toLocaleDateString()} • {u.approved_by || 'admin'}
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={() => revokeUser(u.x_username || u.user_id)}
                        className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                          isDarkMode 
                            ? 'bg-red-900/30 hover:bg-red-900/50 text-red-400' 
                            : 'bg-red-50 hover:bg-red-100 text-red-600'
                        }`}
                      >
                        Revoke
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ==================== SAAS METRICS SECTION ==================== */}
        {activeSection === 'saas' && (
          <>
            {/* Stripe Sync Button */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                  SaaS Metrics Dashboard
                </h3>
                <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  Combines Stripe revenue data with marketing spend
                </p>
              </div>
              <button
                onClick={syncStripeData}
                disabled={syncingStripe}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  syncingStripe
                    ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                    : 'bg-purple-500 hover:bg-purple-600 text-white'
                }`}
              >
                {syncingStripe ? (
                  <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                )}
                {syncingStripe ? 'Syncing...' : 'Sync Stripe Data'}
              </button>
            </div>

            {/* Key SaaS Metrics Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode}
                title="LTV"
                value={`$${saasMetrics?.saas_metrics?.ltv?.toLocaleString() || 0}`}
                tooltip="Customer Lifetime Value - Total gross profit expected from average customer over their lifespan"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode}
                title="CAC"
                value={`$${saasMetrics?.saas_metrics?.cac?.toLocaleString() || 0}`}
                tooltip="Customer Acquisition Cost - Total marketing spend ÷ new customers acquired"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode}
                title="LTV/CAC"
                value={`${saasMetrics?.saas_metrics?.ltv_cac_ratio || 0}x`}
                subtitle={saasMetrics?.saas_metrics?.ltv_cac_ratio >= 3 ? '✓ Healthy (≥3x)' : '⚠ Below target'}
                tooltip="LTV ÷ CAC ratio. 3x+ is healthy, 5x+ is excellent. Measures return on acquisition spend"
                color={saasMetrics?.saas_metrics?.ltv_cac_ratio >= 3 ? 'green' : 'yellow'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="CAC Payback"
                value={`${saasMetrics?.saas_metrics?.cac_payback_months || 0} mo`}
                subtitle={saasMetrics?.saas_metrics?.cac_payback_months <= 12 ? '✓ Under 1 year' : '⚠ Over 1 year'}
                tooltip="Months to recover customer acquisition cost. Under 12 months is healthy for SaaS"
                color={saasMetrics?.saas_metrics?.cac_payback_months <= 12 ? 'green' : 'orange'}
              />
            </div>

            {/* Second Row - Revenue Retention & Efficiency */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode}
                title="NRR"
                value={`${saasMetrics?.saas_metrics?.nrr || 100}%`}
                subtitle={saasMetrics?.saas_metrics?.nrr >= 100 ? '✓ Net positive' : '⚠ Net negative'}
                tooltip="Net Revenue Retention - Revenue retained including expansions. 100%+ means growth from existing customers"
                color={saasMetrics?.saas_metrics?.nrr >= 100 ? 'green' : 'red'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="GRR"
                value={`${saasMetrics?.saas_metrics?.grr || 100}%`}
                tooltip="Gross Revenue Retention - Revenue retained excluding expansions. Shows pure retention health"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode}
                title="Rule of 40"
                value={saasMetrics?.saas_metrics?.rule_of_40 || 0}
                subtitle={saasMetrics?.saas_metrics?.rule_of_40 >= 40 ? '✓ Above 40' : '⚠ Below 40'}
                tooltip="Growth Rate % + Profit Margin %. Score ≥40 indicates healthy SaaS business"
                color={saasMetrics?.saas_metrics?.rule_of_40 >= 40 ? 'green' : 'yellow'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="Magic Number"
                value={saasMetrics?.saas_metrics?.magic_number || 0}
                subtitle={saasMetrics?.saas_metrics?.magic_number >= 0.75 ? '✓ Efficient' : '⚠ Invest more'}
                tooltip="Net New ARR ÷ S&M Spend. >0.75 = efficient, >1 = very efficient, time to invest more"
                color={saasMetrics?.saas_metrics?.magic_number >= 0.75 ? 'green' : 'yellow'}
              />
            </div>

            {/* NEW: Growth & Engagement Metrics Row */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode}
                title="CMGR"
                value={`${saasMetrics?.saas_metrics?.cmgr?.cmgr_pct || 0}%`}
                subtitle={saasMetrics?.saas_metrics?.cmgr?.cmgr_pct >= 10 ? '✓ Strong (≥10%)' : saasMetrics?.saas_metrics?.cmgr?.cmgr_pct >= 5 ? '○ Moderate' : '⚠ Low'}
                tooltip="Compound Monthly Growth Rate - Smoothed month-over-month growth. 10%+ = ~3x YoY, 15%+ = excellent"
                color={saasMetrics?.saas_metrics?.cmgr?.cmgr_pct >= 10 ? 'green' : saasMetrics?.saas_metrics?.cmgr?.cmgr_pct >= 5 ? 'yellow' : 'red'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="DAU/WAU"
                value={`${saasMetrics?.saas_metrics?.engagement?.dau_wau || 0}%`}
                subtitle={saasMetrics?.saas_metrics?.engagement?.dau_wau >= 60 ? '✓ High engagement' : '⚠ Below 60%'}
                tooltip="Daily Active Users ÷ Weekly Active Users. 60%+ means users visit 3+ days/week"
                color={saasMetrics?.saas_metrics?.engagement?.dau_wau >= 60 ? 'green' : 'yellow'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="Stickiness"
                value={`${saasMetrics?.saas_metrics?.engagement?.dau_mau || 0}%`}
                subtitle={saasMetrics?.saas_metrics?.engagement?.dau_mau >= 40 ? '✓ Sticky product' : '⚠ Below 40%'}
                tooltip="DAU/MAU ratio. 40%+ on weekdays = healthy engagement for B2B SaaS"
                color={saasMetrics?.saas_metrics?.engagement?.dau_mau >= 40 ? 'green' : 'yellow'}
              />
              <StatCard isDarkMode={isDarkMode}
                title="Activation (7d)"
                value={`${saasMetrics?.saas_metrics?.activation?.rate_7d || 0}%`}
                subtitle={`${saasMetrics?.saas_metrics?.activation?.activated_7d || 0} of ${saasMetrics?.saas_metrics?.activation?.total_signups_30d || 0} users`}
                tooltip="% of new signups who imported within 7 days. Higher = better onboarding"
                color={saasMetrics?.saas_metrics?.activation?.rate_7d >= 50 ? 'green' : saasMetrics?.saas_metrics?.activation?.rate_7d >= 25 ? 'yellow' : 'red'}
              />
            </div>

            {/* Activation & Engagement Details */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Activation Funnel */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Activation Funnel (Last 30 Days)
                  <Tooltip text="How quickly new users reach their 'aha moment' by importing ideas"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-4">
                  {[
                    { label: 'Within 1 hour', rate: saasMetrics?.saas_metrics?.activation?.rate_1h || 0, count: saasMetrics?.saas_metrics?.activation?.activated_1h || 0, color: 'green' },
                    { label: 'Within 24 hours', rate: saasMetrics?.saas_metrics?.activation?.rate_24h || 0, count: saasMetrics?.saas_metrics?.activation?.activated_24h || 0, color: 'blue' },
                    { label: 'Within 7 days', rate: saasMetrics?.saas_metrics?.activation?.rate_7d || 0, count: saasMetrics?.saas_metrics?.activation?.activated_7d || 0, color: 'purple' },
                  ].map((item, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between mb-1">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.label}</span>
                        <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.rate}% ({item.count} users)</span>
                      </div>
                      <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                        <div className={`h-2 rounded-full bg-${item.color}-500`} style={{ width: `${item.rate}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
                <p className={`text-xs mt-4 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  Total signups (30d): {saasMetrics?.saas_metrics?.activation?.total_signups_30d || 0}
                </p>
              </div>

              {/* Engagement Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Active User Breakdown
                  <Tooltip text="Current active users by time period"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      DAU (Today)
                      <Tooltip text="Users who performed any action today"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-green-500`}>{saasMetrics?.saas_metrics?.engagement?.dau || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      WAU (7 days)
                      <Tooltip text="Unique users active in the last 7 days"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-blue-500`}>{saasMetrics?.saas_metrics?.engagement?.wau || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      MAU (30 days)
                      <Tooltip text="Unique users active in the last 30 days"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-purple-500`}>{saasMetrics?.saas_metrics?.engagement?.mau || 0}</span>
                  </div>
                  <div className={`pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                    <div className="flex items-center justify-between">
                      <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                        WAU/MAU
                        <Tooltip text="Weekly engagement as % of monthly - shows weekly habit formation"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{saasMetrics?.saas_metrics?.engagement?.wau_mau || 0}%</span>
                    </div>
                  </div>
                </div>
                <p className={`text-xs mt-4 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  Benchmarks: DAU/WAU ≥60%, DAU/MAU ≥40% for B2B SaaS
                </p>
              </div>
            </div>

            {/* CMGR Details */}
            {saasMetrics?.saas_metrics?.cmgr?.months > 0 && (
              <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-slate-800/50' : 'bg-slate-100'} mb-6`}>
                <h4 className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  CMGR Calculation
                  <Tooltip text="Compound Monthly Growth Rate smooths lumpy month-over-month growth"><InfoIcon /></Tooltip>
                </h4>
                <div className={`font-mono text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                  <p>Start MRR: ${saasMetrics?.saas_metrics?.cmgr?.start_mrr?.toLocaleString() || 0}</p>
                  <p>End MRR: ${saasMetrics?.saas_metrics?.cmgr?.end_mrr?.toLocaleString() || 0}</p>
                  <p>Period: {saasMetrics?.saas_metrics?.cmgr?.months || 0} months</p>
                  <p className="mt-2 text-green-500 font-bold">CMGR = {saasMetrics?.saas_metrics?.cmgr?.cmgr_pct || 0}%</p>
                  <p className={`text-xs mt-1 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                    10% CMGR ≈ 3x YoY growth | 15% CMGR ≈ 5x YoY growth
                  </p>
                </div>
              </div>
            )}

            {/* Stripe Revenue Data */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Revenue from Stripe
                  <Tooltip text="Real-time revenue data synced from Stripe"><InfoIcon /></Tooltip>
                </h3>
                {saasMetrics?.stripe ? (
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>MRR</span>
                      <span className={`text-lg font-bold text-green-500`}>${saasMetrics.stripe.mrr?.toLocaleString() || 0}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>ARR</span>
                      <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>${saasMetrics.stripe.arr?.toLocaleString() || 0}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>New MRR (30d)</span>
                      <span className={`text-sm font-bold text-blue-500`}>+${saasMetrics.stripe.new_mrr?.toLocaleString() || 0}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Churned MRR (30d)</span>
                      <span className={`text-sm font-bold text-red-500`}>-${saasMetrics.stripe.churned_mrr?.toLocaleString() || 0}</span>
                    </div>
                    <div className={`pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                      <div className="flex justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Active Subscribers</span>
                        <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{saasMetrics.stripe.active_subscribers || 0}</span>
                      </div>
                      <div className="flex justify-between mt-2">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>ARPU</span>
                        <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>${saasMetrics.stripe.arpu || 0}/mo</span>
                      </div>
                    </div>
                    <p className={`text-xs mt-2 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Last synced: {saasMetrics.stripe.synced_at ? new Date(saasMetrics.stripe.synced_at).toLocaleString() : 'Never'}
                    </p>
                  </div>
                ) : (
                  <div className={`text-center py-8 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                    <p>No Stripe data available</p>
                    <p className="text-xs mt-2">Click &quot;Sync Stripe Data&quot; to fetch</p>
                  </div>
                )}
              </div>

              {/* Marketing Spend Input */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Marketing Spend ({marketingSpend.month})
                  <Tooltip text="Enter monthly marketing costs to calculate CAC and LTV/CAC"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div>
                    <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Month</label>
                    <input
                      type="month"
                      value={marketingSpend.month}
                      onChange={(e) => setMarketingSpend(prev => ({ ...prev, month: e.target.value }))}
                      className={`w-full mt-1 px-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        Paid Ads
                        <Tooltip text="Google, X, Facebook ads etc."><InfoIcon /></Tooltip>
                      </label>
                      <div className="relative mt-1">
                        <span className="absolute left-3 top-2 text-slate-400">$</span>
                        <input
                          type="number"
                          value={marketingSpend.paid_ads}
                          onChange={(e) => setMarketingSpend(prev => ({ ...prev, paid_ads: e.target.value }))}
                          placeholder="0"
                          className={`w-full pl-7 pr-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                        />
                      </div>
                    </div>
                    <div>
                      <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        Content/SEO
                        <Tooltip text="Content creation, SEO tools, writers"><InfoIcon /></Tooltip>
                      </label>
                      <div className="relative mt-1">
                        <span className="absolute left-3 top-2 text-slate-400">$</span>
                        <input
                          type="number"
                          value={marketingSpend.content_seo}
                          onChange={(e) => setMarketingSpend(prev => ({ ...prev, content_seo: e.target.value }))}
                          placeholder="0"
                          className={`w-full pl-7 pr-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                        />
                      </div>
                    </div>
                    <div>
                      <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        Sales Salaries
                        <Tooltip text="Sales team salaries focused on new customer acquisition"><InfoIcon /></Tooltip>
                      </label>
                      <div className="relative mt-1">
                        <span className="absolute left-3 top-2 text-slate-400">$</span>
                        <input
                          type="number"
                          value={marketingSpend.sales_salaries}
                          onChange={(e) => setMarketingSpend(prev => ({ ...prev, sales_salaries: e.target.value }))}
                          placeholder="0"
                          className={`w-full pl-7 pr-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                        />
                      </div>
                    </div>
                    <div>
                      <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        Tools & Software
                        <Tooltip text="Marketing tools, CRM, analytics software"><InfoIcon /></Tooltip>
                      </label>
                      <div className="relative mt-1">
                        <span className="absolute left-3 top-2 text-slate-400">$</span>
                        <input
                          type="number"
                          value={marketingSpend.tools_software}
                          onChange={(e) => setMarketingSpend(prev => ({ ...prev, tools_software: e.target.value }))}
                          placeholder="0"
                          className={`w-full pl-7 pr-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                      Other
                      <Tooltip text="Events, sponsorships, other marketing costs"><InfoIcon /></Tooltip>
                    </label>
                    <div className="relative mt-1">
                      <span className="absolute left-3 top-2 text-slate-400">$</span>
                      <input
                        type="number"
                        value={marketingSpend.other}
                        onChange={(e) => setMarketingSpend(prev => ({ ...prev, other: e.target.value }))}
                        placeholder="0"
                        className={`w-full pl-7 pr-3 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-slate-700 text-white border-slate-600' : 'bg-slate-50 text-slate-800 border-slate-200'} border`}
                      />
                    </div>
                  </div>
                  <div className={`pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                    <div className="flex justify-between items-center">
                      <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Total</span>
                      <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        ${((parseFloat(marketingSpend.paid_ads) || 0) + (parseFloat(marketingSpend.content_seo) || 0) + (parseFloat(marketingSpend.sales_salaries) || 0) + (parseFloat(marketingSpend.tools_software) || 0) + (parseFloat(marketingSpend.other) || 0)).toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={saveMarketingSpend}
                    disabled={savingSpend}
                    className={`w-full py-2 rounded-lg text-sm font-medium transition-colors ${
                      savingSpend
                        ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                        : 'bg-orange-500 hover:bg-orange-600 text-white'
                    }`}
                  >
                    {savingSpend ? 'Saving...' : 'Save Marketing Spend'}
                  </button>
                </div>
              </div>
            </div>

            {/* Marketing Spend History */}
            {saasMetrics?.marketing_history?.length > 0 && (
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Marketing Spend History
                  <Tooltip text="Historical marketing spend by month"><InfoIcon /></Tooltip>
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className={isDarkMode ? 'text-slate-400' : 'text-slate-500'}>
                        <th className="text-left py-2">Month</th>
                        <th className="text-right py-2">Paid Ads</th>
                        <th className="text-right py-2">Content</th>
                        <th className="text-right py-2">Sales</th>
                        <th className="text-right py-2">Tools</th>
                        <th className="text-right py-2">Other</th>
                        <th className="text-right py-2 font-bold">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {saasMetrics.marketing_history.map((item, idx) => (
                        <tr key={idx} className={`border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                          <td className={`py-2 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>{item.month}</td>
                          <td className={`py-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>${item.paid_ads?.toLocaleString() || 0}</td>
                          <td className={`py-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>${item.content_seo?.toLocaleString() || 0}</td>
                          <td className={`py-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>${item.sales_salaries?.toLocaleString() || 0}</td>
                          <td className={`py-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>${item.tools_software?.toLocaleString() || 0}</td>
                          <td className={`py-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>${item.other?.toLocaleString() || 0}</td>
                          <td className={`py-2 text-right font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>${item.total?.toLocaleString() || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Metrics Explanation */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800/50' : 'bg-slate-100'}`}>
              <h4 className={`text-sm font-semibold mb-3 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                SaaS Metrics Reference
              </h4>
              <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                <div>
                  <p className="mb-2"><strong>LTV (Lifetime Value):</strong> ARPU × Gross Margin ÷ Churn Rate. Total profit from average customer.</p>
                  <p className="mb-2"><strong>CAC (Customer Acquisition Cost):</strong> Total Marketing Spend ÷ New Customers.</p>
                  <p className="mb-2"><strong>LTV/CAC:</strong> Should be ≥3x. Shows ROI on customer acquisition.</p>
                  <p><strong>CAC Payback:</strong> CAC ÷ (ARPU × Margin). Months to recover acquisition cost.</p>
                </div>
                <div>
                  <p className="mb-2"><strong>NRR (Net Revenue Retention):</strong> Revenue retained including expansions. 100%+ is growth.</p>
                  <p className="mb-2"><strong>GRR (Gross Revenue Retention):</strong> Revenue retained excluding expansions.</p>
                  <p className="mb-2"><strong>Rule of 40:</strong> Growth % + Profit Margin %. Score ≥40 = healthy SaaS.</p>
                  <p><strong>Magic Number:</strong> Net New ARR ÷ S&M Spend. {'>'}0.75 = efficient growth.</p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== REVENUE SECTION ==================== */}
        {activeSection === 'revenue' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="MRR" 
                value={`$${metrics?.revenue?.mrr?.toLocaleString() || 0}`}
                tooltip="Monthly Recurring Revenue - predictable monthly income from subscriptions"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="ARR" 
                value={`$${metrics?.revenue?.arr?.toLocaleString() || 0}`}
                tooltip="Annual Recurring Revenue - MRR × 12, tracks yearly revenue trajectory"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="ARPU" 
                value={`$${metrics?.revenue?.arpu || 0}`}
                tooltip="Average Revenue Per User - total MRR / total users. Shows monetization efficiency"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Paying Users" 
                value={metrics?.revenue?.paying_users || 0}
                subtitle={`${((metrics?.revenue?.paying_users || 0) / (metrics?.totals?.users || 1) * 100).toFixed(1)}% of users`}
                tooltip="Users with active paid subscriptions"
                color="orange"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Conversion & Churn */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Conversion & Churn
                  <Tooltip text="Key metrics for understanding revenue health"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        Trial → Paid Conversion
                        <Tooltip text="% of free users who converted to a paid subscription"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {metrics?.revenue?.trial_to_paid_rate || 0}%
                      </span>
                    </div>
                    <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className="h-2 rounded-full bg-green-500" style={{ width: `${metrics?.revenue?.trial_to_paid_rate || 0}%` }}></div>
                    </div>
                    <p className={`text-xs mt-1 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Benchmark: 2-5% typical, {'>'} 5% excellent
                    </p>
                  </div>
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        Monthly Churn Rate
                        <Tooltip text="% of paying users who cancelled in the last 30 days"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-sm font-bold ${(metrics?.revenue?.churn_rate_monthly || 0) > 5 ? 'text-red-500' : 'text-green-500'}`}>
                        {metrics?.revenue?.churn_rate_monthly || 0}%
                      </span>
                    </div>
                    <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className={`h-2 rounded-full ${(metrics?.revenue?.churn_rate_monthly || 0) > 5 ? 'bg-red-500' : 'bg-green-500'}`} style={{ width: `${Math.min(metrics?.revenue?.churn_rate_monthly || 0, 100)}%` }}></div>
                    </div>
                    <p className={`text-xs mt-1 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      Benchmark: {'<'} 3% good, {'<'} 5% acceptable
                    </p>
                  </div>
                </div>
              </div>

              {/* Revenue Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Revenue by Plan
                  <Tooltip text="MRR breakdown by subscription type"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Monthly ($49/mo)</span>
                    <span className={`text-lg font-bold text-blue-500`}>${metrics?.revenue?.revenue_by_plan?.monthly || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Annual ($468/yr)</span>
                    <span className={`text-lg font-bold text-purple-500`}>${metrics?.revenue?.revenue_by_plan?.annual || 0}</span>
                  </div>
                  <div className={`pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                    <div className="flex items-center justify-between">
                      <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                        Customer LTV
                        <Tooltip text="Lifetime Value estimate - ARPU / churn rate. Predicts total revenue per customer"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>${metrics?.revenue?.ltv_estimate || 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== GROWTH SECTION ==================== */}
        {activeSection === 'growth' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="DAU" 
                value={metrics?.active_users?.dau || 0}
                subtitle="Daily Active Users"
                tooltip="Users who performed any action today (import, share, etc.)"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="WAU" 
                value={metrics?.active_users?.wau || 0}
                subtitle="Weekly Active Users"
                tooltip="Unique users active in the last 7 days"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="MAU" 
                value={metrics?.active_users?.mau || 0}
                subtitle="Monthly Active Users"
                tooltip="Unique users active in the last 30 days"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Stickiness" 
                value={`${metrics?.active_users?.stickiness_pct || 0}%`}
                subtitle="DAU/MAU ratio"
                tooltip="DAU ÷ MAU. Measures how often monthly users return daily. >20% is excellent for SaaS"
                color="orange"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Conversion Funnel
                  <Tooltip text="User journey from signup to key actions"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        Signup → First Import
                        <Tooltip text="% of users who imported at least one bookmark"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.active_users?.signup_to_import_pct || 0}%</span>
                    </div>
                    <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className="h-2 rounded-full bg-green-500" style={{ width: `${metrics?.active_users?.signup_to_import_pct || 0}%` }}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        Users who shared
                        <Tooltip text="% of users who shared at least one idea"><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.adoption?.sharing_pct || 0}%</span>
                    </div>
                    <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className="h-2 rounded-full bg-orange-500" style={{ width: `${metrics?.adoption?.sharing_pct || 0}%` }}></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Daily Active Users (14 days)
                </h3>
                <div className="h-20 flex items-end gap-1">
                  {metrics?.trends?.daily_active?.slice(-14).map((day, idx) => (
                    <div
                      key={idx}
                      className="flex-1 bg-blue-500 rounded-t hover:bg-blue-400 transition-colors"
                      style={{ height: `${Math.max((day.count / maxActive) * 100, 4)}%` }}
                      title={`${day.date}: ${day.count} active`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== RETENTION SECTION ==================== */}
        {activeSection === 'retention' && (
          <>
            <div className="grid grid-cols-3 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="D1 Retention" 
                value={`${metrics?.retention?.d1 || 0}%`}
                subtitle="Active day after signup"
                tooltip="% of users who returned the day after signing up. Critical early engagement signal"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="D7 Retention" 
                value={`${metrics?.retention?.d7 || 0}%`}
                subtitle="Active week after signup"
                tooltip="% of users active 7 days after signup. Shows habit formation"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="D30 Retention" 
                value={`${metrics?.retention?.d30 || 0}%`}
                subtitle="Active month after signup"
                tooltip="% of users active 30 days after signup. Key indicator of long-term value"
                color="purple"
              />
            </div>

            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Retention Curve
                <Tooltip text="Visual representation of user retention over time"><InfoIcon /></Tooltip>
              </h3>
              <div className="flex items-end gap-8 justify-center h-40">
                {[
                  { label: 'D1', value: metrics?.retention?.d1 || 0 },
                  { label: 'D7', value: metrics?.retention?.d7 || 0 },
                  { label: 'D30', value: metrics?.retention?.d30 || 0 },
                ].map((item, idx) => (
                  <div key={idx} className="flex flex-col items-center">
                    <div 
                      className={`w-16 rounded-t ${idx === 0 ? 'bg-green-500' : idx === 1 ? 'bg-blue-500' : 'bg-purple-500'}`}
                      style={{ height: `${Math.max(item.value, 5)}%` }}
                    />
                    <span className={`text-sm font-bold mt-2 ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.value}%</span>
                    <span className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{item.label}</span>
                  </div>
                ))}
              </div>
              <p className={`text-xs text-center mt-4 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                % of users active X days after signup
              </p>
            </div>

            {/* Weekly Cohort Table */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Weekly Cohort Retention
                <Tooltip text="Tracks retention for users who signed up in each week"><InfoIcon /></Tooltip>
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className={isDarkMode ? 'text-slate-400' : 'text-slate-500'}>
                      <th className="text-left py-2 pr-4">Cohort</th>
                      <th className="text-right py-2 px-2">Size</th>
                      <th className="text-right py-2 pl-4">Still Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(metrics?.retention?.cohort_weekly || []).map((cohort, idx) => (
                      <tr key={idx} className={`border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                        <td className={`py-2 pr-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>{cohort.week}</td>
                        <td className={`py-2 px-2 text-right ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{cohort.cohort_size}</td>
                        <td className="py-2 pl-4 text-right">
                          <span className={`font-bold ${cohort.retained >= 50 ? 'text-green-500' : cohort.retained >= 25 ? 'text-yellow-500' : 'text-red-500'}`}>
                            {cohort.retained}%
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {/* ==================== ENGAGEMENT SECTION ==================== */}
        {activeSection === 'engagement' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Time to Value" 
                value={`${Math.round(metrics?.ttfv?.avg_minutes || 0)}m`}
                subtitle="Minutes to first import"
                tooltip="Average time from signup to first import. Shorter is better - shows product delivers value quickly"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Aha Moment Rate" 
                value={`${metrics?.engagement_depth?.aha_moment_rate || 0}%`}
                subtitle="Imported within 1 hour"
                tooltip="% of users who imported their first idea within 1 hour of signup. High rate = strong onboarding"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Churn Risk" 
                value={metrics?.churn?.at_risk_users || 0}
                subtitle={`${metrics?.churn?.at_risk_pct || 0}% inactive 7+ days`}
                tooltip="Users with ideas who haven't been active in 7+ days. Target for re-engagement"
                color="red"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Return Rate (7d)" 
                value={`${metrics?.engagement_depth?.return_7d_rate || 0}%`}
                subtitle="Multi-day active users"
                tooltip="% of WAU who were active on 2+ different days. Shows habitual use"
                color="purple"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Power User Distribution */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  User Engagement Distribution
                  <Tooltip text="Segments users by number of ideas created"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { label: 'Power Users (20+ ideas)', value: metrics?.power_users?.power || 0, color: 'green', tooltip: 'Most engaged users, valuable for feedback and word-of-mouth' },
                    { label: 'Regular Users (6-20 ideas)', value: metrics?.power_users?.regular || 0, color: 'blue', tooltip: 'Consistent users who see value but have room to grow' },
                    { label: 'Casual Users (1-5 ideas)', value: metrics?.power_users?.casual || 0, color: 'slate', tooltip: 'Light users - opportunity to increase engagement' },
                  ].map((item, idx) => {
                    const total = (metrics?.power_users?.power || 0) + (metrics?.power_users?.regular || 0) + (metrics?.power_users?.casual || 0);
                    const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
                    return (
                      <div key={idx}>
                        <div className="flex justify-between mb-1">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                            {item.label}
                            <Tooltip text={item.tooltip}><InfoIcon /></Tooltip>
                          </span>
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.value} ({pct}%)</span>
                        </div>
                        <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                          <div className={`h-2 rounded-full bg-${item.color}-500`} style={{ width: `${pct}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Activity by Day */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Activity by Day of Week
                  <Tooltip text="When users are most active - useful for timing emails and features"><InfoIcon /></Tooltip>
                </h3>
                <div className="h-32 flex items-end gap-2">
                  {(metrics?.activity_patterns?.by_day_of_week || []).map((day, idx) => {
                    const max = Math.max(...(metrics?.activity_patterns?.by_day_of_week || []).map(d => d.count), 1);
                    return (
                      <div key={idx} className="flex-1 flex flex-col items-center">
                        <div 
                          className={`w-full rounded-t ${idx === 0 || idx === 6 ? 'bg-orange-500' : 'bg-blue-500'}`}
                          style={{ height: `${Math.max((day.count / max) * 100, 4)}%` }}
                        />
                        <span className={`text-xs mt-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{day.day}</span>
                        <span className={`text-xs font-bold ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>{day.count}</span>
                      </div>
                    );
                  })}
                </div>
                <p className={`text-xs text-center mt-3 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  Avg {metrics?.activity_patterns?.avg_ideas_per_day || 0} ideas/day (last 30 days)
                </p>
              </div>
            </div>

            {/* Ideas per User Distribution */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Ideas per User Distribution
                <Tooltip text="How ideas are distributed across users"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-3 gap-4">
                {[
                  { label: 'Low (1-10)', value: metrics?.engagement_depth?.ideas_per_user_distribution?.low || 0, color: 'slate' },
                  { label: 'Medium (11-50)', value: metrics?.engagement_depth?.ideas_per_user_distribution?.medium || 0, color: 'blue' },
                  { label: 'High (51+)', value: metrics?.engagement_depth?.ideas_per_user_distribution?.high || 0, color: 'green' },
                ].map((item, idx) => (
                  <div key={idx} className={`p-4 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className={`text-2xl font-bold text-${item.color}-500`}>{item.value}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{item.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* ==================== UI/FEATURE ENGAGEMENT ==================== */}
            <h2 className={`text-lg font-semibold mt-8 mb-4 ${isDarkMode ? 'text-white' : 'text-slate-800'} flex items-center gap-2`}>
              <Icons.BarChart className="w-5 h-5 text-blue-500" />
              Feature & UI Engagement
            </h2>

            {/* Engagement Overview - Totals & Per-User Averages */}
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Modal Clicks" 
                value={metrics?.engagement?.modal_clicks?.total || 0}
                subtitle={`${metrics?.engagement?.per_user?.avg_modal_clicks_per_user || 0} avg/user`}
                tooltip="Total modal button clicks. Per-user avg indicates feature discovery rate."
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Searches" 
                value={metrics?.engagement?.search?.total_searches || 0}
                subtitle={`${metrics?.engagement?.per_user?.avg_searches_per_user || 0} avg/user`}
                tooltip="Total searches performed. Per-user avg shows content discovery behavior."
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Dossiers" 
                value={metrics?.engagement?.dossiers?.total_ordered || 0}
                subtitle={`${metrics?.engagement?.per_user?.avg_dossiers_per_user || 0} avg/user`}
                tooltip="Total research dossiers ordered. Per-user avg indicates premium feature engagement."
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Schedules" 
                value={metrics?.engagement?.schedules?.total_created || 0}
                subtitle={`${metrics?.engagement?.per_user?.avg_schedules_per_user || 0} avg/user`}
                tooltip="Total schedules created. Per-user avg shows research planning behavior."
                color="orange"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Sessions" 
                value={metrics?.engagement?.sessions?.total || 0}
                subtitle={`${Math.round((metrics?.engagement?.per_user?.avg_session_duration || 0) / 60)}m avg duration`}
                tooltip="Total sessions tracked. Avg session duration indicates engagement depth."
                color="slate"
              />
            </div>

            {/* Modal Button Clicks */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Click className="w-4 h-4 text-purple-500" />
                  Modal Button Clicks
                  <Tooltip text="Tracks which action buttons users click most on idea cards"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'original', label: 'Original Document', icon: <Icons.Document className="w-4 h-4 text-blue-500" />, color: 'blue' },
                    { key: 'documents', label: 'Documents/Dossier', icon: <Icons.Folder className="w-4 h-4 text-green-500" />, color: 'green' },
                    { key: 'schedule', label: 'Schedule Research', icon: <Icons.Calendar className="w-4 h-4 text-purple-500" />, color: 'purple' },
                    { key: 'share', label: 'Share Idea', icon: <Icons.Share className="w-4 h-4 text-yellow-500" />, color: 'yellow' },
                    { key: 'watchlist', label: 'Add to Watchlist', icon: <Icons.Star className="w-4 h-4 text-yellow-500" />, color: 'yellow' },
                    { key: 'polls', label: 'Create Poll', icon: <Icons.ChartPie className="w-4 h-4 text-indigo-500" />, color: 'indigo' },
                    { key: 'ai_reaction', label: 'AI Reaction', icon: <Icons.Sparkles className="w-4 h-4 text-pink-500" />, color: 'pink' },
                  ].map((item, idx) => {
                    const count = metrics?.engagement?.modal_clicks?.[item.key] || 0;
                    const total = metrics?.engagement?.modal_clicks?.total || 1;
                    const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                    const activeUsers = metrics?.engagement?.per_user?.total_active_users || 1;
                    const perUser = (count / activeUsers).toFixed(1);
                    return (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                          {item.icon}
                          {item.label}
                        </span>
                        <div className="flex items-center gap-3">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{perUser}/user</span>
                          <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                          <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>({pct}%)</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Total Clicks</span>
                    <div className="flex items-center gap-3">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        {((metrics?.engagement?.modal_clicks?.total || 0) / (metrics?.engagement?.per_user?.total_active_users || 1)).toFixed(1)}/user
                      </span>
                      <span className={`text-lg font-bold text-blue-500`}>{metrics?.engagement?.modal_clicks?.total || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

            {/* Polls Modal Button Clicks */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.ChartPie className="w-4 h-4 text-orange-500" />
                  Polls Action Buttons
                  <Tooltip text="Tracks which action buttons users click on the Polls spreadsheet"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'documents', label: 'Documents/Dossier', icon: <Icons.Folder className="w-4 h-4 text-slate-500" />, color: 'slate' },
                    { key: 'schedule', label: 'Schedule Research', icon: <Icons.Calendar className="w-4 h-4 text-purple-500" />, color: 'purple' },
                    { key: 'share', label: 'Share Idea', icon: <Icons.Share className="w-4 h-4 text-yellow-500" />, color: 'yellow' },
                    { key: 'watchlist', label: 'Add to Watchlist', icon: <Icons.Plus className="w-4 h-4 text-green-500" />, color: 'green' },
                  ].map((item, idx) => {
                    const count = metrics?.engagement?.polls_modal_clicks?.[item.key] || 0;
                    const total = metrics?.engagement?.polls_modal_clicks?.total || 1;
                    const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                    return (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                          {item.icon}
                          {item.label}
                        </span>
                        <div className="flex items-center gap-3">
                          <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                          <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>({pct}%)</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Total Polls Clicks</span>
                    <span className={`text-lg font-bold text-orange-500`}>{metrics?.engagement?.polls_modal_clicks?.total || 0}</span>
                  </div>
                </div>
              </div>

              {/* Watchlist Modal Button Clicks */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Star className="w-4 h-4 text-yellow-500" />
                  Watchlist Action Buttons
                  <Tooltip text="Tracks which action buttons users click on the Watchlist spreadsheet"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'original', label: 'Original Document', icon: <Icons.Document className="w-4 h-4 text-blue-500" />, color: 'blue' },
                    { key: 'documents', label: 'Documents/Dossier', icon: <Icons.Folder className="w-4 h-4 text-slate-500" />, color: 'slate' },
                    { key: 'schedule', label: 'Schedule Research', icon: <Icons.Calendar className="w-4 h-4 text-purple-500" />, color: 'purple' },
                    { key: 'share', label: 'Share Idea', icon: <Icons.Share className="w-4 h-4 text-yellow-500" />, color: 'yellow' },
                    { key: 'delete', label: 'Delete from Watchlist', icon: <Icons.Trash className="w-4 h-4 text-red-500" />, color: 'red' },
                  ].map((item, idx) => {
                    const count = metrics?.engagement?.watchlist_modal_clicks?.[item.key] || 0;
                    const total = metrics?.engagement?.watchlist_modal_clicks?.total || 1;
                    const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                    return (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                          {item.icon}
                          {item.label}
                        </span>
                        <div className="flex items-center gap-3">
                          <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                          <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>({pct}%)</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Total Watchlist Clicks</span>
                    <span className={`text-lg font-bold text-yellow-500`}>{metrics?.engagement?.watchlist_modal_clicks?.total || 0}</span>
                  </div>
                </div>
              </div>
            </div>


              {/* Search Analytics */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Search className="w-4 h-4 text-green-500" />
                  Search Analytics
                  <Tooltip text="How users search - by word, ticker symbol, or source type"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'word', label: 'Word Search', icon: <Icons.Search className="w-3 h-3" />, tooltip: 'Text/keyword searches' },
                    { key: 'ticker', label: 'Ticker Search ($XXX)', icon: <Icons.TrendingUp className="w-3 h-3" />, tooltip: 'Searches for stock symbols' },
                    { key: 'source', label: 'Source Search', icon: <Icons.Filter className="w-3 h-3" />, tooltip: 'Searches by source type (email, bookmark, etc.)' },
                    { key: 'poll', label: 'Poll Search (poll:)', icon: <Icons.ChartPie className="w-3 h-3" />, tooltip: 'Searches within polls using poll: prefix' },
                    { key: 'watchlist', label: 'Watchlist Search (list:)', icon: <Icons.Star className="w-3 h-3" />, tooltip: 'Searches within watchlists using list: prefix' },
                    { key: 'other', label: 'Other', icon: <Icons.Globe className="w-3 h-3" />, tooltip: 'Unclassified searches' },
                  ].map((item, idx) => {
                    const count = metrics?.engagement?.search?.by_type?.[item.key] || 0;
                    const perUser = metrics?.engagement?.search?.by_type_per_user?.[item.key] || 0;
                    return (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                          {item.icon}
                          {item.label}
                          <Tooltip text={item.tooltip}><InfoIcon /></Tooltip>
                        </span>
                        <div className="flex items-center gap-2">
                          <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{perUser}/user</span>
                          <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between mb-2">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Total Searches</span>
                    <span className={`text-lg font-bold text-green-500`}>{metrics?.engagement?.search?.total_searches || 0}</span>
                  </div>
                  <div className="flex justify-between mb-2">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Avg/User</span>
                    <span className={`text-lg font-bold text-blue-500`}>{metrics?.engagement?.per_user?.avg_searches_per_user || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Daily Average</span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.engagement?.search?.daily_avg || 0}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Dossiers & Schedules */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Dossier Analytics */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Folder className="w-4 h-4 text-green-500" />
                  Research Dossiers
                  <Tooltip text="Investment dossier generation analytics"><InfoIcon /></Tooltip>
                </h3>
                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-green-500">{metrics?.engagement?.dossiers?.total_ordered || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Total Ordered</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-blue-500">{metrics?.engagement?.per_user?.avg_dossiers_per_user || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg/User</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-purple-500">{(metrics?.engagement?.dossiers?.top_tickers || []).length}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Unique Tickers</div>
                  </div>
                </div>
                
                {/* Top Tickers for Dossiers */}
                {(metrics?.engagement?.dossiers?.top_tickers || []).length > 0 && (
                  <div className="mb-4">
                    <h4 className={`text-xs font-semibold mb-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Top Researched Tickers</h4>
                    <div className="flex flex-wrap gap-2">
                      {(metrics?.engagement?.dossiers?.top_tickers || []).slice(0, 8).map(([ticker, count], idx) => (
                        <span key={idx} className={`px-2 py-1 rounded text-xs font-medium ${isDarkMode ? 'bg-slate-600 text-slate-200' : 'bg-slate-200 text-slate-700'}`}>
                          ${ticker} ({count})
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Document Types */}
                {Object.keys(metrics?.engagement?.dossiers?.document_types || {}).length > 0 && (
                  <div>
                    <h4 className={`text-xs font-semibold mb-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Document Types Selected</h4>
                    <div className="space-y-1">
                      {Object.entries(metrics?.engagement?.dossiers?.document_types || {}).map(([type, count], idx) => (
                        <div key={idx} className="flex justify-between text-sm">
                          <span className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>{type}</span>
                          <span className={`font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Schedule Analytics */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Calendar className="w-4 h-4 text-purple-500" />
                  Schedule Analytics
                  <Tooltip text="Research scheduling patterns - helps inform best practices"><InfoIcon /></Tooltip>
                </h3>
                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-purple-500">{metrics?.engagement?.schedules?.total_created || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Total Created</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-blue-500">{metrics?.engagement?.per_user?.avg_schedules_per_user || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg/User</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-orange-500">{metrics?.engagement?.schedules?.avg_days_out || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg Days Out</div>
                  </div>
                </div>
                
                {/* Schedule Distance Distribution */}
                <div className="mb-4">
                  <h4 className={`text-xs font-semibold mb-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    How Far Users Schedule
                    <Tooltip text="Distribution of how far in advance users schedule research"><InfoIcon /></Tooltip>
                  </h4>
                  <div className="space-y-2">
                    {[
                      { key: 'same_day', label: 'Same Day', color: 'green' },
                      { key: '1_3_days', label: '1-3 Days', color: 'blue' },
                      { key: '4_7_days', label: '4-7 Days', color: 'purple' },
                      { key: '1_2_weeks', label: '1-2 Weeks', color: 'orange' },
                      { key: '2_plus_weeks', label: '2+ Weeks', color: 'red' },
                    ].map((item, idx) => {
                      const count = metrics?.engagement?.schedules?.schedule_distance?.[item.key] || 0;
                      const total = metrics?.engagement?.schedules?.total_created || 1;
                      const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                      return (
                        <div key={idx} className="flex items-center justify-between">
                          <span className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.label}</span>
                          <div className="flex items-center gap-2">
                            <div className={`w-16 h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                              <div className={`h-2 rounded-full bg-${item.color}-500`} style={{ width: `${pct}%` }}></div>
                            </div>
                            <span className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation & Original Views */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
              {/* Sort Usage */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Sort className="w-4 h-4 text-blue-500" />
                  Sort Menu Usage
                  <Tooltip text="Which sorting options users prefer"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-2">
                  {Object.entries(metrics?.engagement?.navigation?.sort_usage || {}).length > 0 ? (
                    Object.entries(metrics?.engagement?.navigation?.sort_usage || {}).map(([sort, count], idx) => (
                      <div key={idx} className="flex justify-between text-sm">
                        <span className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>{sort}</span>
                        <span className={`font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                      </div>
                    ))
                  ) : (
                    <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                  )}
                </div>
                <div className={`mt-3 pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between text-sm">
                    <span className={isDarkMode ? 'text-slate-400' : 'text-slate-500'}>Total</span>
                    <div className="flex items-center gap-2">
                      <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                        {metrics?.engagement?.per_user?.avg_sort_usage_per_user || 0}/user
                      </span>
                      <span className={`font-bold text-blue-500`}>{metrics?.engagement?.navigation?.total_sort_usage || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Source Menu Usage */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Filter className="w-4 h-4 text-green-500" />
                  Source Filter Usage
                  <Tooltip text="Which source filters users apply most"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-2">
                  {Object.entries(metrics?.engagement?.navigation?.source_menu_usage || {}).length > 0 ? (
                    Object.entries(metrics?.engagement?.navigation?.source_menu_usage || {}).map(([source, count], idx) => (
                      <div key={idx} className="flex justify-between text-sm">
                        <span className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>{source}</span>
                        <span className={`font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                      </div>
                    ))
                  ) : (
                    <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                  )}
                </div>
                <div className={`mt-3 pt-3 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between text-sm">
                    <span className={isDarkMode ? 'text-slate-400' : 'text-slate-500'}>Total</span>
                    <div className="flex items-center gap-2">
                      <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                        {metrics?.engagement?.per_user?.avg_source_menu_per_user || 0}/user
                      </span>
                      <span className={`font-bold text-green-500`}>{metrics?.engagement?.navigation?.total_source_menu_usage || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Original Document Views */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Document className="w-4 h-4 text-blue-500" />
                  Original Document Views
                  <Tooltip text="How often users view original content by source"><InfoIcon /></Tooltip>
                </h3>
                <div className="flex items-center justify-center gap-4 mb-4">
                  <div className="text-center">
                    <div className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                      {metrics?.engagement?.original_views?.total || 0}
                    </div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>Total</div>
                  </div>
                  <div className="text-center">
                    <div className={`text-xl font-bold text-blue-500`}>
                      {metrics?.engagement?.per_user?.avg_original_views_per_user || 0}
                    </div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>Avg/User</div>
                  </div>
                </div>
                <div className="space-y-2">
                  {Object.entries(metrics?.engagement?.original_views?.by_source || {}).length > 0 ? (
                    Object.entries(metrics?.engagement?.original_views?.by_source || {}).map(([source, count], idx) => (
                      <div key={idx} className="flex justify-between text-sm">
                        <span className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>{source}</span>
                        <span className={`font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                      </div>
                    ))
                  ) : (
                    <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                  )}
                </div>
              </div>
            </div>

            {/* ==================== SESSION & DEVICE ANALYTICS ==================== */}
            <h2 className={`text-lg font-semibold mt-8 mb-4 ${isDarkMode ? 'text-white' : 'text-slate-800'} flex items-center gap-2`}>
              <Icons.Clock className="w-5 h-5 text-purple-500" />
              Session & Device Analytics
            </h2>

            {/* Session Overview Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Total Sessions" 
                value={metrics?.engagement?.sessions?.total || 0}
                subtitle={`${metrics?.engagement?.per_user?.total_active_users || 0} active users`}
                tooltip="Total number of unique user sessions tracked"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Session Duration" 
                value={`${Math.round((metrics?.engagement?.sessions?.avg_duration_seconds || 0) / 60)}m`}
                subtitle={`${metrics?.engagement?.sessions?.avg_duration_seconds || 0}s total`}
                tooltip="Average time users spend on the site per session"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Total Time on Site" 
                value={`${Math.round((metrics?.engagement?.time_on_site?.total_seconds || 0) / 3600)}h`}
                subtitle={`${Math.round((metrics?.engagement?.time_on_site?.avg_session_seconds || 0) / 60)}m avg/session`}
                tooltip="Total time all users have spent on the platform"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Desktop %" 
                value={`${metrics?.engagement?.device_breakdown?.desktop?.percentage || 0}%`}
                subtitle={`${metrics?.engagement?.device_breakdown?.desktop?.sessions || 0} sessions`}
                tooltip="Percentage of sessions from desktop devices"
                color="orange"
              />
            </div>

            {/* Device Breakdown & Time by Tab */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Device Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Mobile className="w-4 h-4 text-blue-500" />
                  Device Breakdown
                  <Tooltip text="Sessions split by device type - helps optimize for your users' devices"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-4">
                  {[
                    { key: 'desktop', label: 'Desktop', icon: <Icons.Desktop className="w-4 h-4" />, color: 'blue' },
                    { key: 'mobile', label: 'Mobile', icon: <Icons.Mobile className="w-4 h-4" />, color: 'green' },
                    { key: 'tablet', label: 'Tablet', icon: <Icons.Tablet className="w-4 h-4" />, color: 'purple' },
                  ].map((item, idx) => {
                    const data = metrics?.engagement?.device_breakdown?.[item.key] || { sessions: 0, percentage: 0 };
                    return (
                      <div key={idx}>
                        <div className="flex justify-between mb-1">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                            {item.icon}
                            {item.label}
                          </span>
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                            {data.sessions} ({data.percentage}%)
                          </span>
                        </div>
                        <div className={`w-full h-3 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                          <div 
                            className={`h-3 rounded-full bg-${item.color}-500 transition-all`} 
                            style={{ width: `${data.percentage}%` }}
                          ></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                {/* iOS vs Android Breakdown */}
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'} flex items-center gap-2`}>
                    <Icons.Mobile className="w-3 h-3" />
                    iOS vs Android
                    <Tooltip text="Mobile OS breakdown - helps prioritize platform-specific features"><InfoIcon /></Tooltip>
                  </h4>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { key: 'ios', label: 'iOS', icon: <Icons.Apple className="w-4 h-4" />, color: 'blue' },
                      { key: 'android', label: 'Android', icon: <Icons.Android className="w-4 h-4" />, color: 'green' },
                    ].map((item, idx) => {
                      const data = metrics?.engagement?.os_breakdown?.[item.key] || { sessions: 0, percentage: 0 };
                      return (
                        <div key={idx} className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                          <div className="flex justify-center mb-1">{item.icon}</div>
                          <div className={`text-2xl font-bold text-${item.color}-500`}>{data.percentage}%</div>
                          <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{item.label}</div>
                          <div className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{data.sessions} sessions</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                
                {/* Time by Device */}
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'} flex items-center gap-2`}>
                    <Icons.Clock className="w-3 h-3" />
                    Time Spent by Device
                  </h4>
                  <div className="grid grid-cols-3 gap-2 text-center">
                    {['desktop', 'mobile', 'tablet'].map((device) => {
                      const seconds = metrics?.engagement?.time_on_site?.by_device?.[device] || 0;
                      const minutes = Math.round(seconds / 60);
                      return (
                        <div key={device} className={`p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                          <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{minutes}m</div>
                          <div className={`text-xs capitalize ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{device}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Time Spent by Tab/Section */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Clock className="w-4 h-4 text-orange-500" />
                  Time Spent by Section
                  <Tooltip text="Where users spend the most time - valuable for prioritizing features"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {Object.entries(metrics?.engagement?.time_on_site?.by_tab || {}).length > 0 ? (
                    Object.entries(metrics?.engagement?.time_on_site?.by_tab || {})
                      .sort((a, b) => b[1] - a[1])
                      .map(([tab, seconds], idx) => {
                        const minutes = Math.round(seconds / 60);
                        const totalSeconds = metrics?.engagement?.time_on_site?.total_seconds || 1;
                        const pct = Math.round((seconds / totalSeconds) * 100);
                        return (
                          <div key={idx}>
                            <div className="flex justify-between mb-1">
                              <span className={`text-sm capitalize ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{tab}</span>
                              <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{minutes}m ({pct}%)</span>
                            </div>
                            <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                              <div className="h-2 rounded-full bg-orange-500" style={{ width: `${pct}%` }}></div>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                  )}
                </div>
                
                {/* Tab Views Count */}
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    Tab Views (Clicks)
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {Object.entries(metrics?.engagement?.tab_views || {}).length > 0 ? (
                      Object.entries(metrics?.engagement?.tab_views || {})
                        .sort((a, b) => b[1] - a[1])
                        .map(([tab, count], idx) => (
                          <span key={idx} className={`px-2 py-1 rounded text-xs font-medium capitalize ${isDarkMode ? 'bg-slate-600 text-slate-200' : 'bg-slate-200 text-slate-700'}`}>
                            {tab}: {count}
                          </span>
                        ))
                    ) : (
                      <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* OS & Browser Breakdown */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Full OS Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Desktop className="w-4 h-4 text-purple-500" />
                  Operating System Breakdown
                  <Tooltip text="Full OS distribution across all sessions"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'ios', label: 'iOS', icon: <Icons.Apple className="w-4 h-4" />, color: 'blue' },
                    { key: 'android', label: 'Android', icon: <Icons.Android className="w-4 h-4" />, color: 'green' },
                    { key: 'windows', label: 'Windows', icon: <Icons.Windows className="w-4 h-4" />, color: 'purple' },
                    { key: 'macos', label: 'macOS', icon: <Icons.Apple className="w-4 h-4" />, color: 'slate' },
                    { key: 'linux', label: 'Linux', icon: <Icons.Linux className="w-4 h-4" />, color: 'orange' },
                  ].map((item, idx) => {
                    const data = metrics?.engagement?.os_breakdown?.[item.key] || { sessions: 0, percentage: 0 };
                    return (
                      <div key={idx}>
                        <div className="flex justify-between mb-1">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                            {item.icon}
                            {item.label}
                          </span>
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                            {data.sessions} ({data.percentage}%)
                          </span>
                        </div>
                        <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                          <div className={`h-2 rounded-full bg-${item.color}-500`} style={{ width: `${data.percentage}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Browser Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Globe className="w-4 h-4 text-blue-500" />
                  Browser Breakdown
                  <Tooltip text="Which browsers users access the app from"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { key: 'chrome', label: 'Chrome', icon: <Icons.Chrome className="w-4 h-4" />, color: 'blue' },
                    { key: 'safari', label: 'Safari', icon: <Icons.Safari className="w-4 h-4" />, color: 'purple' },
                    { key: 'firefox', label: 'Firefox', icon: <Icons.Firefox className="w-4 h-4" />, color: 'orange' },
                    { key: 'edge', label: 'Edge', icon: <Icons.Edge className="w-4 h-4" />, color: 'green' },
                    { key: 'other', label: 'Other', icon: <Icons.Globe className="w-4 h-4" />, color: 'slate' },
                  ].map((item, idx) => {
                    const data = metrics?.engagement?.browser_breakdown?.[item.key] || { sessions: 0, percentage: 0 };
                    return (
                      <div key={idx}>
                        <div className="flex justify-between mb-1">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                            {item.icon}
                            {item.label}
                          </span>
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                            {data.sessions} ({data.percentage}%)
                          </span>
                        </div>
                        <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                          <div className={`h-2 rounded-full bg-${item.color}-500`} style={{ width: `${data.percentage}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* ==================== BOOKMARK GROWTH (X Engagement - Per User) ==================== */}
            <h2 className={`text-lg font-semibold mt-8 mb-4 ${isDarkMode ? 'text-white' : 'text-slate-800'} flex items-center gap-2`}>
              <Icons.TrendingUp className="w-5 h-5 text-green-500" />
              X Bookmark Growth (Per-User Analysis)
              <span className={`text-xs ml-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                Track if users increase their X engagement over time
              </span>
            </h2>

            {/* Per-User Overview Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Bookmarks/User" 
                value={metrics?.bookmark_growth?.per_user?.avg_bookmarks_per_user || 0}
                subtitle={`Median: ${metrics?.bookmark_growth?.per_user?.median_bookmarks_per_user || 0}`}
                tooltip="Average bookmarks imported per user - key metric for engagement depth"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Returning User Growth" 
                value={`${metrics?.bookmark_growth?.cohort_growth?.returning_users_growth || 0}%`}
                subtitle="Existing users' avg change"
                tooltip="Are existing users importing MORE bookmarks? Positive = increased X engagement"
                color={metrics?.bookmark_growth?.cohort_growth?.returning_users_growth >= 0 ? "green" : "red"}
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Returning Users %" 
                value={`${metrics?.bookmark_growth?.cohort_growth?.new_vs_returning?.returning_user_pct || 0}%`}
                subtitle={`${metrics?.bookmark_growth?.cohort_growth?.new_vs_returning?.returning_user_imports || 0} users`}
                tooltip="% of this month's importers who also imported in previous months - retention indicator"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Imports/User" 
                value={metrics?.bookmark_growth?.per_user?.avg_imports_per_user || 0}
                subtitle={`${metrics?.bookmark_growth?.per_user?.avg_bookmarks_per_import || 0} per import`}
                tooltip="How frequently users import - higher = more engaged with the feature"
                color="orange"
              />
            </div>

            {/* Bookmark Trends & User Stats */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Monthly Trend - Per User */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.BarChart className="w-4 h-4 text-blue-500" />
                  Monthly Avg Bookmarks Per User
                  <Tooltip text="Track if average bookmarks per user is growing - the key engagement metric"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {(metrics?.bookmark_growth?.monthly_trend || []).slice(0, 6).map((month, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between mb-1">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{month.month}</span>
                        <div className="flex items-center gap-2">
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                            {month.avg_per_user} avg/user
                          </span>
                          {month.growth_pct !== 0 && (
                            <span className={`text-xs ${month.growth_pct >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                              {month.growth_pct >= 0 ? '↑' : '↓'} {Math.abs(month.growth_pct)}%
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between text-xs mb-1">
                        <span className={isDarkMode ? 'text-slate-500' : 'text-slate-400'}>
                          {month.unique_users} users
                        </span>
                        <span className={isDarkMode ? 'text-slate-500' : 'text-slate-400'}>
                          {month.total_bookmarks} total
                        </span>
                      </div>
                      <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                        <div 
                          className={`h-2 rounded-full ${month.growth_pct >= 0 ? 'bg-green-500' : 'bg-blue-500'}`} 
                          style={{ width: `${Math.min((month.avg_per_user / 100) * 100, 100)}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
                {(metrics?.bookmark_growth?.monthly_trend || []).length === 0 && (
                  <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
                )}
              </div>

              {/* User Segments & Cohort Analysis */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.Users className="w-4 h-4 text-purple-500" />
                  User Segments & Behavior
                  <Tooltip text="Understand your user base by engagement level"><InfoIcon /></Tooltip>
                </h3>
                
                {/* User Segments */}
                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-green-500">{metrics?.bookmark_growth?.user_segments?.power_users || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Power (100+)</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-blue-500">{metrics?.bookmark_growth?.user_segments?.active_users || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Active (10-99)</div>
                  </div>
                  <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className="text-2xl font-bold text-slate-500">{metrics?.bookmark_growth?.user_segments?.light_users || 0}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Light (1-9)</div>
                  </div>
                </div>

                {/* Cohort: New vs Returning */}
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    This Month: New vs Returning Importers
                  </h4>
                  <div className="grid grid-cols-2 gap-3">
                    <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                      <div className="text-xl font-bold text-orange-500">{metrics?.bookmark_growth?.cohort_growth?.new_vs_returning?.new_user_imports || 0}</div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>New Users</div>
                    </div>
                    <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                      <div className="text-xl font-bold text-blue-500">{metrics?.bookmark_growth?.cohort_growth?.new_vs_returning?.returning_user_imports || 0}</div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Returning Users</div>
                    </div>
                  </div>
                </div>
                
                {/* Import Frequency */}
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    Active Importers
                    <Tooltip text="Unique users who imported bookmarks in each time period"><InfoIcon /></Tooltip>
                  </h4>
                  <div className="grid grid-cols-3 gap-2 text-center">
                    <div className={`p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                      <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {metrics?.bookmark_growth?.import_frequency?.daily_importers || 0}
                      </div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Today</div>
                    </div>
                    <div className={`p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                      <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {metrics?.bookmark_growth?.import_frequency?.weekly_importers || 0}
                      </div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>This Week</div>
                    </div>
                    <div className={`p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                      <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {metrics?.bookmark_growth?.import_frequency?.monthly_importers || 0}
                      </div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>This Month</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Weekly Trend - Per User */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                <Icons.Calendar className="w-4 h-4 text-green-500" />
                Weekly Avg Bookmarks Per User (Last 8 Weeks)
                <Tooltip text="Week-by-week per-user average - shows if engagement is growing"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                {(metrics?.bookmark_growth?.weekly_trend || []).slice(0, 8).map((week, idx) => (
                  <div key={idx} className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'} mb-1`}>
                      Week of {week.week}
                    </div>
                    <div className="flex items-center justify-between">
                      <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                        {week.avg_per_user}
                      </span>
                      {week.growth_pct !== 0 && (
                        <span className={`text-xs ${week.growth_pct >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                          {week.growth_pct >= 0 ? '↑' : '↓'} {Math.abs(week.growth_pct)}%
                        </span>
                      )}
                    </div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      {week.unique_users} users • {week.total_bookmarks} total
                    </div>
                  </div>
                ))}
              </div>
              {(metrics?.bookmark_growth?.weekly_trend || []).length === 0 && (
                <p className={`text-sm ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No data yet</p>
              )}
            </div>
          </>
        )}

        {/* ==================== VIRALITY SECTION ==================== */}
        {activeSection === 'virality' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="K-Factor" 
                value={metrics?.virality?.k_factor || 0}
                subtitle="Viral coefficient"
                tooltip="Invites per user × conversion rate. >1 means viral growth (each user brings more than 1 new user)"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Invite Acceptance" 
                value={`${metrics?.virality?.invitation_acceptance_rate || 0}%`}
                subtitle="Share acceptance rate"
                tooltip="% of share invitations that were accepted. Higher = more effective sharing"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Shares/User" 
                value={metrics?.virality?.shares_per_user || 0}
                subtitle="Avg shares per user"
                tooltip="Total shares ÷ total users. Shows sharing culture strength"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Referred Users" 
                value={metrics?.virality?.organic_vs_referred_split?.referred || 0}
                subtitle="From shares/invites"
                tooltip="Users who signed up after receiving a shared idea or group invite"
                color="orange"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Organic vs Referred */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  User Acquisition Source
                  <Tooltip text="Organic users found you themselves; Referred users came from shares/invites"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-4">
                  {[
                    { label: 'Organic', value: metrics?.virality?.organic_vs_referred_split?.organic || 0, color: 'blue' },
                    { label: 'Referred', value: metrics?.virality?.organic_vs_referred_split?.referred || 0, color: 'green' },
                  ].map((item, idx) => {
                    const total = (metrics?.virality?.organic_vs_referred_split?.organic || 0) + (metrics?.virality?.organic_vs_referred_split?.referred || 0);
                    const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
                    return (
                      <div key={idx}>
                        <div className="flex justify-between mb-1">
                          <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.label}</span>
                          <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.value} ({pct}%)</span>
                        </div>
                        <div className={`w-full h-3 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                          <div className={`h-3 rounded-full bg-${item.color}-500`} style={{ width: `${pct}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <p className={`text-xs mt-4 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                  Target: 20%+ referred for sustainable growth
                </p>
              </div>

              {/* Viral Growth Explanation */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Viral Growth Formula
                  <Tooltip text="How K-factor is calculated"><InfoIcon /></Tooltip>
                </h3>
                <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} font-mono text-sm`}>
                  <div className={`${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                    K = invites × conversion<br/>
                    K = {metrics?.virality?.shares_per_user || 0} × {((metrics?.virality?.invitation_acceptance_rate || 0) / 100).toFixed(3)}<br/>
                    <span className="text-green-500 font-bold">K = {metrics?.virality?.k_factor || 0}</span>
                  </div>
                </div>
                <div className={`mt-4 text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  <p><span className="text-green-500">● K {'>'} 1.0</span> = Viral (exponential growth)</p>
                  <p><span className="text-yellow-500">● K = 0.5-1.0</span> = Good word-of-mouth</p>
                  <p><span className="text-red-500">● K {'<'} 0.5</span> = Limited virality</p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== IMPORTS SECTION ==================== */}
        {activeSection === 'imports' && (
          <>
            {/* Summary Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Daily Imports" 
                value={metrics?.per_user_imports?.import_activity_summary?.daily_imports || 0}
                subtitle="Last 24 hours"
                tooltip="Total import sessions across all users in the last 24 hours"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Weekly Imports" 
                value={metrics?.per_user_imports?.import_activity_summary?.weekly_imports || 0}
                subtitle="Last 7 days"
                tooltip="Total import sessions across all users in the last 7 days"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Monthly Imports" 
                value={metrics?.per_user_imports?.import_activity_summary?.monthly_imports || 0}
                subtitle="Last 30 days"
                tooltip="Total import sessions across all users in the last 30 days"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Avg/User (Weekly)" 
                value={metrics?.per_user_imports?.import_activity_summary?.weekly_avg_per_user || 0}
                subtitle="Imports per user"
                tooltip="Average number of import sessions per user in the last 7 days"
                color="orange"
              />
            </div>

            {/* Per-User Import Table */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
              <div className="flex items-center justify-between mb-4">
                <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Per-User Import Statistics
                  <Tooltip text="Detailed import breakdown by user - shows bookmarks downloaded and ideas extracted"><InfoIcon /></Tooltip>
                </h3>
                <button
                  onClick={() => {
                    const users = metrics?.per_user_imports?.user_import_details || [];
                    if (users.length === 0) return;
                    
                    const headers = ['User', 'Email', 'Total Imports', 'Total Bookmarks', 'Ideas', 'Ideas with Tickers', 'Extraction Rate %', 'Daily Bookmarks', 'Weekly Bookmarks', 'Monthly Bookmarks', 'Last Import'];
                    const rows = users.map(u => [
                      u.display_name,
                      u.email_masked,
                      u.total_imports,
                      u.total_bookmarks,
                      u.total_ideas,
                      u.ideas_with_tickers,
                      u.extraction_rate,
                      u.daily?.bookmarks || 0,
                      u.weekly?.bookmarks || 0,
                      u.monthly?.bookmarks || 0,
                      u.last_import ? new Date(u.last_import).toLocaleDateString() : 'N/A'
                    ]);
                    
                    const csvContent = [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `tickler_import_stats_${new Date().toISOString().split('T')[0]}.csv`;
                    link.click();
                    URL.revokeObjectURL(url);
                  }}
                  className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                    isDarkMode 
                      ? 'bg-slate-700 text-slate-300 hover:bg-slate-600' 
                      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Export CSV
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className={isDarkMode ? 'text-slate-400' : 'text-slate-500'}>
                      <th className="text-left py-2 pr-2">User</th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Total bookmarks pulled across all imports"><span>Total Bookmarks</span></Tooltip>
                      </th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Total ideas created from imports"><span>Ideas</span></Tooltip>
                      </th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Ideas with at least one ticker extracted"><span>Extracted</span></Tooltip>
                      </th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Bookmarks downloaded in last 24 hours"><span>Daily</span></Tooltip>
                      </th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Bookmarks downloaded in last 7 days"><span>Weekly</span></Tooltip>
                      </th>
                      <th className="text-right py-2 px-2">
                        <Tooltip text="Bookmarks downloaded in last 30 days"><span>Monthly</span></Tooltip>
                      </th>
                      <th className="text-right py-2 pl-2">Last Import</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(metrics?.per_user_imports?.user_import_details || []).map((user, idx) => (
                      <tr key={idx} className={`border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                        <td className={`py-3 pr-2 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                          <div className="flex flex-col">
                            <span className="font-medium">{user.display_name}</span>
                            <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{user.email_masked}</span>
                          </div>
                        </td>
                        <td className={`py-3 px-2 text-right font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                          {user.total_bookmarks?.toLocaleString() || 0}
                        </td>
                        <td className={`py-3 px-2 text-right ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                          {user.total_ideas?.toLocaleString() || 0}
                        </td>
                        <td className="py-3 px-2 text-right">
                          <span className={user.extraction_rate >= 70 ? 'text-green-500' : user.extraction_rate >= 50 ? 'text-yellow-500' : 'text-red-500'}>
                            {user.ideas_with_tickers || 0} ({user.extraction_rate || 0}%)
                          </span>
                        </td>
                        <td className={`py-3 px-2 text-right ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                          {user.daily?.bookmarks || 0}
                        </td>
                        <td className={`py-3 px-2 text-right ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                          {user.weekly?.bookmarks || 0}
                        </td>
                        <td className={`py-3 px-2 text-right ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>
                          {user.monthly?.bookmarks || 0}
                        </td>
                        <td className={`py-3 pl-2 text-right text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                          {user.last_import ? new Date(user.last_import).toLocaleDateString() : 'N/A'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(!metrics?.per_user_imports?.user_import_details || metrics.per_user_imports.user_import_details.length === 0) && (
                  <p className={`text-center py-8 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>No import data available</p>
                )}
              </div>
            </div>

            {/* Import Metrics Explanation */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800/50' : 'bg-slate-100'}`}>
              <h4 className={`text-sm font-semibold mb-3 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Understanding Import Metrics
              </h4>
              <div className={`text-xs space-y-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                <p><strong>Total Bookmarks:</strong> Raw X bookmarks downloaded via the import feature</p>
                <p><strong>Ideas:</strong> Investment ideas created from the bookmarks (some bookmarks may not become ideas)</p>
                <p><strong>Extracted:</strong> Ideas where AI successfully identified stock tickers - higher % = better content quality</p>
                <p><strong>Daily/Weekly/Monthly:</strong> Bookmarks downloaded in each time period (includes all import sessions)</p>
              </div>
            </div>
          </>
        )}

        {/* ==================== FEATURES SECTION ==================== */}
        {activeSection === 'features' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Watchlist Adoption" 
                value={`${metrics?.adoption?.watchlist_pct || 0}%`}
                subtitle={`${metrics?.adoption?.users_with_watchlists || 0} users`}
                tooltip="% of users who created at least one watchlist to track specific tickers"
                color="yellow"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Watchlists/User" 
                value={metrics?.adoption?.avg_watchlists_per_user || 0}
                subtitle={`${metrics?.adoption?.total_watchlists || 0} total`}
                tooltip="Average number of watchlists created per user (among users who have watchlists)"
                color="yellow"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Tickers/Watchlist" 
                value={metrics?.adoption?.avg_watchlist_items || 0}
                subtitle="Avg per watchlist"
                tooltip="Average number of tickers users add to each watchlist"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Group Adoption" 
                value={`${metrics?.adoption?.group_pct || 0}%`}
                subtitle={`${metrics?.adoption?.users_in_groups || 0} users`}
                tooltip="% of users who joined or created at least one group"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Sharing Adoption" 
                value={`${metrics?.adoption?.sharing_pct || 0}%`}
                subtitle={`${metrics?.adoption?.users_who_shared || 0} users`}
                tooltip="% of users who shared at least one idea"
                color="orange"
              />
            </div>

            {/* Groups & Polls Detail */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Group Size Distribution */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Groups by Size
                  <Tooltip text="Distribution of groups by member count"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { label: 'Small (1-3 members)', value: metrics?.groups?.size_distribution?.small || 0, color: 'slate', tooltip: 'Personal or small team groups' },
                    { label: 'Medium (4-10 members)', value: metrics?.groups?.size_distribution?.medium || 0, color: 'blue', tooltip: 'Active collaboration groups' },
                    { label: 'Large (11+ members)', value: metrics?.groups?.size_distribution?.large || 0, color: 'purple', tooltip: 'Community-sized groups' },
                  ].map((item, idx) => {
                    const total = (metrics?.groups?.size_distribution?.small || 0) + (metrics?.groups?.size_distribution?.medium || 0) + (metrics?.groups?.size_distribution?.large || 0);
                    const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
                    return (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                          {item.label}
                          <Tooltip text={item.tooltip}><InfoIcon /></Tooltip>
                        </span>
                        <div className="flex items-center gap-2">
                          <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.value}</span>
                          <span className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>({pct}%)</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>Avg Members/Group</span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.groups?.avg_size || 0}</span>
                  </div>
                </div>
              </div>

              {/* Poll Stats */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Poll Engagement
                  <Tooltip text="In-app polls used to gather investment opinions"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Total Polls Created
                      <Tooltip text="Number of in-app polls created by all users"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.polls?.total || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Total Responses
                      <Tooltip text="Sum of all votes across all polls"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-blue-500`}>{metrics?.polls?.total_responses || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Avg Responses/Poll
                      <Tooltip text="Average number of votes per poll"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.polls?.avg_responses_per_poll || 0}</span>
                  </div>
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="flex justify-between items-center">
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                      Completion Rate
                      <Tooltip text="% of polls that received at least one response"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold ${(metrics?.polls?.completion_rate_pct || 0) >= 50 ? 'text-green-500' : 'text-yellow-500'}`}>
                      {metrics?.polls?.completion_rate_pct || 0}%
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* X Polls & Ask for Ideas */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Polls vs Ask for Ideas Breakdown */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.ChartPie className="w-4 h-4 text-orange-500" />
                  X: Polls vs Ask for Ideas
                  <Tooltip text="Posts via @savetotickler - Polls have multiple choice options, Ask for Ideas are open-ended requests"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                      <Icons.ChartPie className="w-3 h-3 text-orange-500" />
                      Multiple Choice Polls
                      <Tooltip text="Posts with A), B), etc. poll options"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-orange-500`}>{metrics?.fishing_threads?.polls || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'} flex items-center gap-2`}>
                      <Icons.Lightbulb className="w-3 h-3 text-blue-500" />
                      Ask for Ideas
                      <Tooltip text="Open-ended requests for investment ideas"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-blue-500`}>{metrics?.fishing_threads?.ask_for_ideas || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Total Threads
                      <Tooltip text="All @savetotickler threads combined"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.fishing_threads?.total || 0}</span>
                  </div>
                </div>
                {/* Visual bar showing distribution */}
                {(metrics?.fishing_threads?.total || 0) > 0 && (
                  <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                    <div className="flex gap-1 h-4 rounded overflow-hidden">
                      <div 
                        className="bg-orange-500" 
                        style={{ width: `${(metrics?.fishing_threads?.polls || 0) / (metrics?.fishing_threads?.total || 1) * 100}%` }}
                        title={`Polls: ${metrics?.fishing_threads?.polls || 0}`}
                      />
                      <div 
                        className="bg-blue-500" 
                        style={{ width: `${(metrics?.fishing_threads?.ask_for_ideas || 0) / (metrics?.fishing_threads?.total || 1) * 100}%` }}
                        title={`Ask for Ideas: ${metrics?.fishing_threads?.ask_for_ideas || 0}`}
                      />
                    </div>
                    <div className="flex justify-between mt-2 text-xs">
                      <span className="text-orange-400">Polls {Math.round((metrics?.fishing_threads?.polls || 0) / (metrics?.fishing_threads?.total || 1) * 100)}%</span>
                      <span className="text-blue-400">Ask for Ideas {Math.round((metrics?.fishing_threads?.ask_for_ideas || 0) / (metrics?.fishing_threads?.total || 1) * 100)}%</span>
                    </div>
                  </div>
                )}
              </div>

              {/* X Thread Engagement */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                  <Icons.XLogo className="w-4 h-4 text-blue-400" />
                  X Thread Engagement
                  <Tooltip text="Engagement metrics from @savetotickler threads"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Total Replies
                      <Tooltip text="Sum of all replies across all threads"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-green-500`}>{metrics?.fishing_threads?.total_replies || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Tickers Discovered
                      <Tooltip text="Investment tickers extracted from replies"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold text-purple-500`}>{metrics?.fishing_threads?.total_tickers_discovered || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                      Unique Participants
                      <Tooltip text="Unique X users who participated"><InfoIcon /></Tooltip>
                    </span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.fishing_threads?.unique_participants || 0}</span>
                  </div>
                </div>
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="text-center">
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg Replies/Thread</div>
                      <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.fishing_threads?.avg_replies_per_thread || 0}</div>
                    </div>
                    <div className="text-center">
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg Tickers/Thread</div>
                      <div className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.fishing_threads?.avg_tickers_per_thread || 0}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Feature Adoption Bars */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Feature Adoption Rates
                <Tooltip text="What % of users have used each feature at least once"><InfoIcon /></Tooltip>
              </h3>
              <div className="space-y-4">
                {[
                  { label: 'Watchlists', value: metrics?.adoption?.watchlist_pct || 0, color: 'yellow', tooltip: 'Track specific tickers' },
                  { label: 'Groups', value: metrics?.adoption?.group_pct || 0, color: 'purple', tooltip: 'Collaborate with others' },
                  { label: 'Sharing', value: metrics?.adoption?.sharing_pct || 0, color: 'orange', tooltip: 'Share ideas with others' },
                ].map((item, idx) => (
                  <div key={idx}>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        {item.label}
                        <Tooltip text={item.tooltip}><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{item.value}%</span>
                    </div>
                    <div className={`w-full h-3 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className={`h-3 rounded-full bg-${item.color}-500`} style={{ width: `${item.value}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ==================== CALENDAR METRICS ==================== */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mt-6`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                <Icons.Calendar className="w-4 h-4 text-blue-500" />
                Calendar & Scheduling Metrics
                <Tooltip text="User interaction with research scheduling features"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-blue-400`}>{metrics?.calendar?.avg_items_scheduled_per_day || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Avg Items/Day</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-green-400`}>{metrics?.calendar?.calendar_tab_clicks || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Calendar Tab Clicks</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-purple-400`}>{metrics?.calendar?.cross_off_usage || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Cross-offs</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-orange-400`}>{metrics?.calendar?.completion_rate_pct || 0}%</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Completion Rate</div>
                </div>
              </div>
              
              {/* Modal Button Clicks */}
              <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Modal Button Clicks</h4>
                <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
                  {[
                    { label: 'Schedule', value: metrics?.calendar?.modal_button_clicks?.schedule || 0, color: 'blue' },
                    { label: 'Documents', value: metrics?.calendar?.modal_button_clicks?.documents || 0, color: 'green' },
                    { label: 'Share', value: metrics?.calendar?.modal_button_clicks?.share || 0, color: 'orange' },
                    { label: 'Watchlist', value: metrics?.calendar?.modal_button_clicks?.watchlist || 0, color: 'yellow' },
                    { label: 'Original', value: metrics?.calendar?.modal_button_clicks?.original || 0, color: 'purple' },
                    { label: 'AI React', value: metrics?.calendar?.modal_button_clicks?.ai_reaction || 0, color: 'pink' },
                  ].map((btn, idx) => (
                    <div key={idx} className={`text-center p-2 rounded ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                      <div className={`text-lg font-bold text-${btn.color}-400`}>{btn.value}</div>
                      <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{btn.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Schedule Stats */}
              <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Total Scheduled</span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.calendar?.total_scheduled_items || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Completed</span>
                    <span className="text-lg font-bold text-green-400">{metrics?.calendar?.items_completed || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Pending</span>
                    <span className="text-lg font-bold text-yellow-400">{metrics?.calendar?.items_pending || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Users w/ Schedules</span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.calendar?.users_with_schedules || 0}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* ==================== FILES METRICS ==================== */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mt-6`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'} flex items-center gap-2`}>
                <Icons.Folder className="w-4 h-4 text-green-500" />
                Files & Viewer Metrics
                <Tooltip text="User interaction with research files and document viewers"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-green-400`}>{metrics?.files?.total_files_created || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Files Created</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-blue-400`}>{metrics?.files?.total_file_views || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Total Views</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-purple-400`}>{metrics?.files?.todays_file_open_rate_pct || 0}%</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Today's File Opens</div>
                </div>
                <div className="text-center p-3 rounded-lg bg-slate-700/50">
                  <div className={`text-2xl font-bold text-orange-400`}>{metrics?.files?.files_shared || 0}</div>
                  <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Files Shared</div>
                </div>
              </div>

              {/* File Stats */}
              <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Unique Files Viewed</span>
                    <span className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{metrics?.files?.unique_files_viewed || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Avg Views/File</span>
                    <span className="text-lg font-bold text-blue-400">{metrics?.files?.avg_views_per_file || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Users Viewing Files</span>
                    <span className="text-lg font-bold text-green-400">{metrics?.files?.users_viewing_files || 0}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Older Files Opened %</span>
                    <span className="text-lg font-bold text-purple-400">{metrics?.files?.older_files_viewed_pct || 0}%</span>
                  </div>
                </div>
              </div>

              {/* Most Viewed Files */}
              {metrics?.files?.most_viewed_files && metrics.files.most_viewed_files.length > 0 && (
                <div className={`mt-4 pt-4 border-t ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                  <h4 className={`text-xs font-semibold mb-3 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>Most Viewed Files</h4>
                  <div className="space-y-2">
                    {metrics.files.most_viewed_files.map((file, idx) => (
                      <div key={idx} className="flex items-center justify-between">
                        <span className={`text-sm ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>{file.ticker}</span>
                        <span className="text-sm font-bold text-blue-400">{file.views} views</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* ==================== CONTENT SECTION ==================== */}
        {activeSection === 'content' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Ideas/User" 
                value={metrics?.content?.avg_ideas_per_user || 0}
                tooltip="Total ideas ÷ total users. Shows content depth per user"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Avg Tickers/Idea" 
                value={metrics?.content?.avg_tickers_per_idea || 0}
                tooltip="How many tickers AI extracts per idea on average. Shows AI effectiveness"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Extraction Rate" 
                value={`${metrics?.content_quality?.import_to_extraction_ratio || 0}%`}
                tooltip="% of ideas that have at least one ticker extracted. Higher = better AI parsing"
                color="purple"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Total Tickers" 
                value={metrics?.content?.total_tickers_extracted || 0}
                tooltip="Sum of all tickers extracted across all ideas"
                color="orange"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Top Tickers */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Top 10 Trending Tickers
                  <Tooltip text="Most mentioned tickers across all users (aggregate only)"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-2">
                  {(metrics?.content?.top_tickers || []).map((ticker, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className={`text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center ${
                          idx < 3 ? 'bg-orange-500 text-white' : isDarkMode ? 'bg-slate-700 text-slate-300' : 'bg-slate-200 text-slate-600'
                        }`}>
                          {idx + 1}
                        </span>
                        <span className={`font-mono font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>
                          ${ticker.ticker}
                        </span>
                      </div>
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        {ticker.count} mentions
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Ideas by Source */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Ideas by Source
                  <Tooltip text="Where ideas were imported from"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-2">
                  {Object.entries(metrics?.content?.ideas_by_source || {}).slice(0, 8).map(([source, count], idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        {source.replace('x_bookmark', 'X Bookmark').replace('_', ' ')}
                      </span>
                      <span className={`font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Most Saved Ideas */}
            {metrics?.content_quality?.most_saved_ideas?.length > 0 && (
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Most Shared Ideas
                  <Tooltip text="Ideas that have been shared the most times"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-2">
                  {metrics?.content_quality?.most_saved_ideas.map((idea, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className={`font-mono font-bold text-orange-500`}>${idea.ticker}</span>
                        <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{idea.title}</span>
                      </div>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{idea.share_count} shares</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Extraction Trend */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Extraction Rate Trend (4 weeks)
                <Tooltip text="% of ideas with successful ticker extraction over time"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-4 gap-4">
                {(metrics?.content_quality?.extraction_trend || []).map((week, idx) => (
                  <div key={idx} className={`p-3 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'} text-center`}>
                    <div className={`text-lg font-bold ${week.ratio >= 70 ? 'text-green-500' : 'text-yellow-500'}`}>{week.ratio}%</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{week.week}</div>
                    <div className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>{week.ideas} ideas</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* ==================== JOURNEY SECTION ==================== */}
        {activeSection === 'journey' && (
          <>
            {/* Onboarding Funnel */}
            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm mb-6`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                Onboarding Funnel
                <Tooltip text="User progression through key milestones"><InfoIcon /></Tooltip>
              </h3>
              <div className="space-y-4">
                {[
                  { label: 'Signed Up', value: metrics?.user_journey?.onboarding_completion_funnel?.signup || 0, pct: 100 },
                  { label: 'First Import', value: metrics?.user_journey?.onboarding_completion_funnel?.first_import || 0, pct: Math.round(((metrics?.user_journey?.onboarding_completion_funnel?.first_import || 0) / (metrics?.user_journey?.onboarding_completion_funnel?.signup || 1)) * 100) },
                  { label: 'First Share', value: metrics?.user_journey?.onboarding_completion_funnel?.first_share || 0, pct: Math.round(((metrics?.user_journey?.onboarding_completion_funnel?.first_share || 0) / (metrics?.user_journey?.onboarding_completion_funnel?.signup || 1)) * 100) },
                  { label: 'Joined Group', value: metrics?.user_journey?.onboarding_completion_funnel?.first_group || 0, pct: Math.round(((metrics?.user_journey?.onboarding_completion_funnel?.first_group || 0) / (metrics?.user_journey?.onboarding_completion_funnel?.signup || 1)) * 100) },
                  { label: 'Created Watchlist', value: metrics?.user_journey?.onboarding_completion_funnel?.first_watchlist || 0, pct: Math.round(((metrics?.user_journey?.onboarding_completion_funnel?.first_watchlist || 0) / (metrics?.user_journey?.onboarding_completion_funnel?.signup || 1)) * 100) },
                ].map((step, idx) => (
                  <div key={idx}>
                    <div className="flex justify-between mb-1">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{step.label}</span>
                      <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{step.value} ({step.pct}%)</span>
                    </div>
                    <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                      <div className="h-2 rounded-full bg-orange-500" style={{ width: `${step.pct}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Feature Discovery & User Segments */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
              {/* Feature Discovery */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  Feature Discovery (First 7 Days)
                  <Tooltip text="% of new users who discovered each feature within their first week"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {Object.entries(metrics?.user_journey?.feature_discovery_rate_7d || {}).map(([feature, rate], idx) => (
                    <div key={idx}>
                      <div className="flex justify-between mb-1">
                        <span className={`text-sm capitalize ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{feature}</span>
                        <span className={`text-sm font-bold ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>{rate}%</span>
                      </div>
                      <div className={`w-full h-2 rounded-full ${isDarkMode ? 'bg-slate-700' : 'bg-slate-200'}`}>
                        <div className="h-2 rounded-full bg-blue-500" style={{ width: `${rate}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* User Segments */}
              <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
                <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                  User Segments
                  <Tooltip text="Current state of your user base by activity level"><InfoIcon /></Tooltip>
                </h3>
                <div className="space-y-3">
                  {[
                    { label: 'New', value: metrics?.user_journey?.user_segments?.new || 0, color: 'green', tooltip: 'Signed up in last 7 days' },
                    { label: 'Active', value: metrics?.user_journey?.user_segments?.active || 0, color: 'blue', tooltip: 'Active in last 7 days (not new)' },
                    { label: 'Dormant', value: metrics?.user_journey?.user_segments?.dormant || 0, color: 'yellow', tooltip: 'Inactive 7-30 days, may re-engage' },
                    { label: 'Churned', value: metrics?.user_journey?.user_segments?.churned || 0, color: 'red', tooltip: 'Inactive 30+ days, likely lost' },
                  ].map((segment, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <span className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                        {segment.label}
                        <Tooltip text={segment.tooltip}><InfoIcon /></Tooltip>
                      </span>
                      <span className={`text-lg font-bold text-${segment.color}-500`}>{segment.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* ==================== HEALTH SECTION ==================== */}
        {activeSection === 'health' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              <StatCard isDarkMode={isDarkMode} 
                title="Import Success Rate" 
                value={`${metrics?.health?.import_success_rate || 100}%`}
                subtitle="X API health"
                tooltip="% of bookmark imports that successfully pulled posts. Lower = API issues"
                color="green"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Share Acceptance" 
                value={`${metrics?.health?.share_acceptance_rate || 0}%`}
                subtitle="Invite conversion"
                tooltip="% of shared ideas that were accepted by recipients"
                color="blue"
              />
              <StatCard isDarkMode={isDarkMode} 
                title="Total Imports" 
                value={metrics?.health?.total_imports || 0}
                subtitle="All time"
                tooltip="Total number of bookmark import operations performed"
                color="purple"
              />
            </div>

            <div className={`p-5 rounded-xl ${isDarkMode ? 'bg-slate-800' : 'bg-white'} shadow-sm`}>
              <h3 className={`text-sm font-semibold mb-4 ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                System Health
                <Tooltip text="Status of external integrations and services"><InfoIcon /></Tooltip>
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`w-3 h-3 rounded-full ${(metrics?.health?.import_success_rate || 100) >= 90 ? 'bg-green-500' : 'bg-yellow-500'}`}></div>
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>X API</span>
                  </div>
                  <p className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    {(metrics?.health?.import_success_rate || 100) >= 90 ? 'Healthy' : 'Degraded'}
                  </p>
                </div>
                <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-slate-700' : 'bg-slate-100'}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    <span className={`text-sm font-medium ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>Database</span>
                  </div>
                  <p className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    {metrics?.totals?.ideas || 0} ideas stored
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Privacy Footer */}
        <div className={`mt-6 p-4 rounded-xl ${isDarkMode ? 'bg-slate-800/50' : 'bg-slate-100'} text-center`}>
          <p className={`text-xs ${isDarkMode ? 'text-slate-500' : 'text-slate-500'}`}>
            Privacy-first analytics • No individual user tracking • All data aggregate • YC-compliant
          </p>
          <p className={`text-xs mt-1 ${isDarkMode ? 'text-slate-600' : 'text-slate-400'}`}>
            Last updated: {metrics?.generated_at ? new Date(metrics.generated_at).toLocaleString() : 'N/A'}
          </p>
        </div>
      </div>
    </div>
  );
}
